import React, {
  useEffect,
  useState,
  ChangeEvent,
  useRef,
  HtmlHTMLAttributes,
  useMemo,
} from "react";
import {
  TextField,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Box,
  Stack,
  Modal,
  Divider,
  SvgIcon,
  Autocomplete,
  Switch,
  CircularProgress,
  TextareaAutosize,
  Tooltip,
  Collapse,
  Paper,
  FormControlLabel,
  Checkbox,
  LinearProgress,
  RadioGroup,
  Radio,
  ListItemIcon,
  Menu as MuiMenu,
} from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import FolderIcon from "@mui/icons-material/Folder";
import InsightsIcon from "@mui/icons-material/Insights";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { Person2Outlined } from "@mui/icons-material";
import RohanImg from "../../../assets/podcast_monster/rohan_png.png";
import Header from "../../../components/headers/Header";
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import AddIcon from "@mui/icons-material/Add";
import "../generated_blogs.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReactComponent as CardIcon } from "../../../assets/card_ico.svg";
import { ReactComponent as TwitterIcon } from "../../../assets/traffic_monster/icon_twitter.svg";
// import { ReactComponent as XIcon } from '../../../assets/traffic_monster/x_ico.svg';
import { ReactComponent as PinterestIcon } from "../../../assets/traffic_monster/pinterest_ico.svg";
import { ReactComponent as FacebookIcon } from "../../../assets/traffic_monster/fb_ico.svg";
import { ReactComponent as LinkedinIcon } from "../../../assets/traffic_monster/linkedIn_ico.svg";
import {
  BorderAll,
  CheckBox,
  FormatColorFill,
  Height,
  Widgets,
} from "@mui/icons-material";
import { ReactComponent as ClipIco } from "../../../assets/ocesha_images/clip_ico.svg";
import { ReactComponent as EpisodeIco } from "../../../assets/ocesha_images/episode_ico.svg";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as VerifiedIcon } from "../../../assets/verified_ico.svg";
import { isBrowser, isMobile } from "react-device-detect";
import { useCreateCampaignMutation } from "../../../redux/api/promptApi";
import { toast } from "react-toastify";
import { useLazyCreateCheckoutSessionQuery } from "../../../redux/api/subscriptionApi";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import {
  usePlanDetailsMutation,
  useCampaignDetailsMutation,
} from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetpagefrocampaignMutation,
  useGetCnameEntriesMutation,
  useUpdateAutoPublishFlagMutation,
  useGetverifyscriptMutation,
  useCheckverifiedMutation,
} from "../../../redux/api/promptApi";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { id } from "date-fns/locale";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { IPlanDetail } from "../../../redux/api/types";
import { useLazyGetProductQuery } from "../../../redux/api/productApi";
import { useAppSelector } from "../../../redux/store";
import { ReactComponent as Twitterico } from "../../../assets/traffic_monster/twitter__ico.svg";
import { ReactComponent as Pinterestico } from "../../../assets/traffic_monster/pinterest__ico.svg";
import { ReactComponent as Fbico } from "../../../assets/traffic_monster/fb__ico.svg";
import { ReactComponent as Linkedinico } from "../../../assets/traffic_monster/linkedin__ico.svg";
import axios from "axios";
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import InfoIcon from "@mui/icons-material/Info";
import YouTubeIcon from "@mui/icons-material/YouTube";
import youtubeIco1 from "../../../assets/traffic_monster/youtubeIco_1.png";
import { upload } from "@testing-library/user-event/dist/upload";
import ProgressBar from "@ramonak/react-progress-bar";
import {
  setCookie,
  getCookie,
  removeCookie,
} from "../../../utils/storageUtils";
import { urPK } from "@mui/x-date-pickers";
import { useAppDispatch } from "../../../redux/store";
import { logout } from "redux/features/userSlice";
import ocesha_logo from "../../../assets/ocesha_images/ocesha_logo.png";
import { ReactComponent as BlogsIco } from "../../../assets/ocesha_images/blogs_ico.svg";
import { ReactComponent as VideoIco } from "../../../assets/ocesha_images/video_ico.svg";
import { ReactComponent as AudioIco } from "../../../assets/ocesha_images/audio_ico.svg";
import { ReactComponent as ImagesIco } from "../../../assets/ocesha_images/images_ico.svg";
import { ReactComponent as TeamIco } from "../../../assets/ocesha_images/team_ico.svg";
import { ReactComponent as IntegrationIco } from "../../../assets/ocesha_images/integration_ico.svg";
import { ReactComponent as UpgradeIco } from "../../../assets/ocesha_images/upgrade_ico.svg";
import { ReactComponent as BillingIco } from "../../../assets/ocesha_images/billing_ico.svg";
import { ReactComponent as SettingsIco } from "../../../assets/ocesha_images/settings_ico.svg";
import { ReactComponent as HelpIco } from "../../../assets/ocesha_images/help_ico.svg";
import { ReactComponent as LogoutIco } from "../../../assets/ocesha_images/logout_ico.svg";
import { ReactComponent as DashboardIco } from "../../../assets/ocesha_images/dashboard_ico.svg";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { redirectAfterLogout } from "../../../utils/logoutRedirect";

interface ErrorResponse {
  error: {
    status: number;
    data: {
      detail: string;
    };
  };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: '#D0D5DD',
    color: "lightblack",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#161b22",
    color: "#e5e7eb",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#0d1117", // Set background color for even rows to gray
    color: "darkslategray",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HeaderCell = styled("div")(({ theme }) => ({
  color: "#9ca3af",
  fontWeight: "bold",
  fontSize: "14px",
  padding: "12px",
  textAlign: "center",
  "&:nth-child(odd)": {
    backgroundColor: "#161b22",
  },
  "&:nth-child(even)": {
    backgroundColor: "#0d1117",
  },
}));

const DataCell = styled("div")(({ theme }) => ({
  color: "#d1d5db",
  fontSize: "14px",
  padding: "12px",
  textAlign: "center",
  "&:nth-child(odd)": {
    backgroundColor: "#161b22",
  },
  "&:nth-child(even)": {
    backgroundColor: "#0d1117",
  },
}));

const New_Campaign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { FromEdit } = location.state || {};
  const { campIdFrEdit } = location.state || {};
  const { subscriptionFromCampList } = location.state || {};
  const { subscriptionTH } = location.state || {};
  const { mode } = location.state || {};

  //console.log(subscriptionTH);
  //console.log(mode);
  const [sourceUrl, setSourceUrl] = useState<string>(
    localStorage.getItem("ErrorAlert") === "true" &&
      localStorage.getItem("UrlfromLanding")
      ? localStorage.getItem("UrlfromLanding") || ""
      : "",
  );
  const [blogcount, setBlogCount] = useState<any>(1);
  const [sourceYoutubeUrl, setSourceYoutubeUrl] = useState<any>(
    localStorage.getItem("ErrorAlert") === "true" &&
      localStorage.getItem("YoutubeUrlfromLanding")
      ? localStorage.getItem("YoutubeUrlfromLanding") || ""
      : "",
  );
  const [sourceText, setSourceText] = useState<string>("");
  const [videoTag, setVideoTag] = useState<string>(sourceYoutubeUrl || "");
  const [twitterUrl, settwitterUrl] = useState<string>("");
  const [fbUrl, setfbUrl] = useState<string>("");
  const [pintrestUrl, setPintrestUrl] = useState<string>("");
  const [linkedinUrl, setLinkedinUrl] = useState<string>("");
  const [ctaLabel, setCtaLabel] = useState<string>("");
  const [ctaLink, setCtaLink] = useState<string>("");

  const [campaignName, setCampaignName] = useState<string>("");
  const [urlPrefix, setUrlPrefix] = useState<string>(
    localStorage.getItem("ErrorAlert") === "true" &&
      localStorage.getItem("YoutubeUrlfromLanding")
      ? "youtubeid"
      : localStorage.getItem("ErrorAlert") === "true" &&
          localStorage.getItem("UrlfromLanding")
        ? "https://"
        : "https://",
  );
  const [expanded, setExpanded] = useState(true);
  const [expanded1, setExpanded1] = useState(true);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const [expanded7, setExpanded7] = useState(false);
  const [expanded8, setExpanded8] = useState(false);
  const [expanded9, setExpanded9] = useState(false);
  const [expanded10, setExpanded10] = useState(false);
  const [expanded11, setExpanded11] = useState(false);
  const [expanded12, setExpanded12] = useState(false);
  const [expanded14, setExpanded14] = useState(false);
  const [expanded15, setExpanded15] = useState(false);
  const [expanded13, setExpanded13] = useState(false);
  const [planDetails, setPlanDetails] = useState<any>();
  const [campDetails, setCampDetails] = useState<any>();
  const [defaultPlanDetails, setDefaultPlanDetails] = useState<any>();
  const [campaignId, setCampaignId] = useState<any>();
  const [userDetails, setUserDetails] = useState<any>();
  const [openpaymentInstructModal, setOpenPaymentInstructModal] =
    useState<boolean>(false);
  const [paymentOption, setPaymentOption] = useState<any>();
  const [paymentOptYearlyCal, setPaymentOptYearlyCal] = useState<any>();
  const paymentSectionRef = useRef<HTMLDivElement>(null);
  const getcnameEntriesRef = useRef<HTMLDivElement>(null);
  const getVerifyScript = useRef<HTMLDivElement>(null);
  const [autoPublish, setAutopublish] = useState<any>(false);
  const [publishToOcesha, setPublishToOcesha] = useState<any>(false);
  const [publishToCodegenie, setPublishToCodegenie] = useState<any>(false);
  const [competitorSearch, setCompetitorSearch] = useState<any>(false);
  const [limitPublish, setLimitPublish] = useState<any>(true);
  const [socialMediaUrlPublish, setSocialMediaUrlPublish] = useState<any>();
  const [addtags, setAddTags] = useState<any>(true);
  const [externalLinks, setExternalLinks] = useState<any>(true);
  const [toc, setToc] = useState<any>(true);
  const [capturleads, setCapturLeads] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [newsletter, setNewsLetter] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [twitternbutton, setTwitternButton] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [fbbutton, setFbButton] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [pintrestbutton, setPintrestButton] = useState<any>(true);
  const [linkedinbutton, setLinkedinButton] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [video, setVideo] = useState<any>(!!planDetails?.embed_youtube_video);
  const [useOwnDomain, setUseOwnDomain] = useState<any>(false);
  const [isloadingGetPage, setIsLoadingGetPage] = useState<boolean>(false);
  const [openGetPagesuccessModal, setOpenGetPageSuccessModal] =
    useState<boolean>(false);
  const [confirmCancelSubscription, setConfirmCancelSubscription] =
    useState<boolean>(false);
  const [cnameRecords, setCnameRecords] = useState<any>();
  const [cnameDomainName, setCnameDomainName] = useState<any>();
  const [isLoadingCnameRec, setIsLoadingCnameRec] = useState<boolean>(false);
  const getpageRunref = useRef(false);
  const [script, setScript] = useState<any>();
  const [verifyCheck, setVerifyCheck] = useState<any>();
  const [period, getPeriodState] = useState("monthly");
  const [createCampaignMutation] = useCreateCampaignMutation();
  const user_email =
    localStorage.getItem("user_email") || getCookie("user_email") || "";
  const [isUpdateLoader, setIsUpdateLoader] = useState<boolean>(false);
  const [selectedSubscriptionLevel, setSelectedSubscriptionLevel] =
    useState<string>("");

  const [getProduct, getState] = useState<any>(); //useLazyGetProductQuery();
  const [plans, setPlans] = useState<IPlanDetail[]>([
    {
      user: 1,
      plan_name: "",
      total_wishes: 0,
      price: "",
      period: "",
      product_id: "",
      price_id: "",
      subscription_level: "",
      feature: [],
      contracts: 0,
      type: "",
      button_text: "",
      save: "",
    },
  ]);
  const [productModule, setProductModule] = useState("");
  const genieSelector = useAppSelector((state) => state.genieState);

  const [createCheckoutSession, checkoutState] =
    useLazyCreateCheckoutSessionQuery();
  const [getUserDetailsMutation] = useGetUserDetailsMutation();

  // console.log('is this from edit=>', FromEdit);
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const [getuserCampDetails] = useCampaignDetailsMutation();
  const [getPageforCampaign] = useGetpagefrocampaignMutation();
  const [getCnameEntriesMutation] = useGetCnameEntriesMutation();
  const [getverifyscript] = useGetverifyscriptMutation();
  const [getcheckverified] = useCheckverifiedMutation();
  const [updateAutoPublishCheckMutation] = useUpdateAutoPublishFlagMutation();

  const [userImage, setUserImage] = useState<File | null>(null);
  const [userImageUrl, setUserImageUrl] = useState("");
  const [socialUrl, setSocialUrl] = useState("");
  const [name, setName] = useState("");
  const [useAsDefault, setUseAsDefault] = useState(false);
  const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
  const [campaignListMutation] = useCampaignListMutation();
  const [campaignDatas, setCampaignDatas] = useState<any>();
  const [couponCode, setCouponCode] = useState<string>("");
  const [successCancelSubscription, setSuccessCancelSubscription] =
    useState(false);
  const [podcastoryoutubeurl, setPodcastOrYoutubeUrl] = useState("");
  const [selectedSection, setSelectedSection] = useState("websiteSection");
  const [uploadVideo, setUploadVideo] = useState("");
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [uploadedvideopath, setUploadedvideopath] = useState("");
  const [getPageError, setGetPageError] = useState(false);
  const [loaderProgress, setLoaderProgress] = useState<any>(4);
  const [userBusinessText, setUserBusinessText] = useState("");
  const [upgradeModal, setUpgradeModal] = useState<boolean>(false);

  const [loadingText, setLoadingText] = useState<any>(
    <Typography fontSize="18px">
      <b>Analyzing Your Content</b>
      <br />
      We’re using AI Agents to read through your content, analyze your content,
      and will suggest some ideas that we can write about
    </Typography>,
  );
  const [intervaltime, setIntervalTime] = useState(2000);
  const handleCouponTextChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCouponCode(event.target.value);
  };
  const [helpervideosrc, setHelperVideoSrc] = useState<any>();
  const [helperPopup, setHelperPopup] = useState<boolean>(false);
  const [isScrapcheckloading, setIsScrapcheckloading] =
    useState<boolean>(false);
  const [activeItem, setActiveItem] = useState(
    localStorage.getItem("activeItem") || "dashboard",
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContentOpen, setIsContentOpen] = useState(true);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);
  const isProfileMenuOpen = Boolean(profileMenuAnchor);
  const [topics, setTopics] = useState<any>();
  const [topicsList, setTopicsList] = useState<boolean>(false);
  const [selectedTopic, setSelectedTopic] = useState<any>();
  const [keywords, setKeywords] = useState<any>();
  const [keywordsList, setKeywordsList] = useState<boolean>(false);
  const [selectedKeyword, setSelectedKeyword] = useState<any>();
  const [isKeywordLoader, setIsKeywordLoader] = useState<boolean>(false);
  //console.log("localStorage......");
  //console.log(localStorage)

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const handleExpandClick1 = () => {
    setExpanded1(!expanded1);
  };
  const handleExpandClick2 = () => {
    if (planDetails?.plan_name === "ENTERPRISE") {
      setExpanded2(!expanded2);
    } else {
      setUpgradeModal(true);
    }
  };
  const handleExpandClick3 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded3(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded3(false);
                return false;
            } */
    if (planDetails?.white_label_options === true) {
      setExpanded3(!expanded3);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick4 = () => {
    setExpanded4(!expanded4);
  };

  const handleExpandClick5 = () => {
    setExpanded5(!expanded5);
  };

  const handleExpandClick6 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded6(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded6(false);
                return false;
            } */
    setExpanded6(!expanded6);
  };

  const handleExpandClick7 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {

            setExpanded7(false);
            return false;
        }
        if (planDetails)

            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded7(false);
                return false;
            } */

    if (
      planDetails?.embed_contact_form_newsletters_social_media_share === true
    ) {
      setExpanded7(!expanded7);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick8 = () => {
    /*  if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
             || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
             || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
             || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
             setExpanded8(false);
             return false;
         }
         if (planDetails)
             if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                 setExpanded8(false);
                 return false;
             } */
    if (
      planDetails?.embed_contact_form_newsletters_social_media_share === true
    ) {
      setExpanded8(!expanded8);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick9 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded9(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded9(false);
                return false;
            } */
    if (
      planDetails?.embed_contact_form_newsletters_social_media_share === true
    ) {
      setExpanded9(!expanded9);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick10 = () => {
    setExpanded10(!expanded10);
  };

  const handleExpandClick11 = () => {
    if (planDetails?.embed_youtube_video === true) {
      setExpanded11(!expanded11);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick12 = () => {
    setExpanded12(!expanded12);
  };

  const handleExpandClick14 = () => {
    setExpanded14(!expanded14);
  };

  const handleExpandClick15 = () => {
    setExpanded15(!expanded15);
  };

  useEffect(() => {
    const campaignRes = async () => {
      try {
        const response = await campaignListMutation({
          email: user_email || getCookie("user_email") || "",
        });
        if ("data" in response) {
          setCampaignDatas(response.data);
          console.log("campaign list response=>", response.data);
        } else {
          console.error("Error fetching campaign List:", response.error);
        }
      } catch (error) {
        console.log("Error fetching campaign List:", error);
      }
    };
    campaignRes();
  }, [user_email]);

  useEffect(() => {
    localStorage.removeItem("publishingCampId");
  }, []);

  // useEffect(() => {

  //     const value = {
  //         _id: "",
  //         product_name: "CodeGenie",
  //         //product_module: genieSelector.module ? genieSelector.module : ""
  //         product_module: `${process.env.REACT_APP_MAIN_PRODUCT_NAME}`,
  //         userid: "",
  //         productid: ""
  //     };
  //     getProduct(value);
  // }, [genieSelector, getProduct]);

  // useEffect(() => {

  //     const { data } = getState;
  //     if (data?.plan_details) {
  //         console.log(data?.plan_details);
  //         setPlans([...data.plan_details]);
  //         console.log('plan price det=>', plans);
  //         setProductModule(data.product_module);
  //     }
  //     else
  //         setPlans([
  //             {
  //                 user: 1,
  //                 plan_name: "",
  //                 total_wishes: 0,
  //                 price: "",
  //                 period: "",
  //                 product_id: "",
  //                 price_id: "",
  //                 subscription_level: "",
  //                 feature: [],
  //                 contracts: 0,
  //                 type: "",
  //                 button_text: "",
  //                 save: ''
  //             },
  //         ]);
  // }, [getState]);

  const validateCampaignName = () => {
    /* if(campaignName === ''){
            toast.error('Please fill your Campaign Name!');
            return false;
        } */

    const isDuplicate = campaignDatas.some(
      (campaign: any) => campaign.campaign_name === campaignName,
    );
    if (isDuplicate) {
      toast.error("Duplicate campaign Name. Please choose a different name!");
      return false;
    }
    return true;
  };

  const youtubeMatch = videoTag?.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  );
  //console.log('plan details =>', plans);
  const handleCreateCampaignClickold = async () => {
    if (
      FromEdit === "startEditing" ||
      localStorage.getItem("ChangepayMode") === "true"
    ) {
      if (video && !videoTag) {
        toast.error("Please enter YouTube video URL on video section");
      } else if (video && !youtubeMatch) {
        toast.error("Please enter only YouTube video URL");
      } else {
        autoPublishCheck(campIdFrEdit);
        handleUpdateSetting(campIdFrEdit);
        localStorage.removeItem("ChangepayMode");
        localStorage.removeItem("IdChangingMode");
      }
      // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
      // if(planDetails?.owndomain === '1'){

      // }
    } else {
      // debugger;
      // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
      if (
        campaignName ===
        "" /* || sourceUrl === '' || !paymentOption || (!limitPublish && !autoPublish) */
      ) {
        // toast.error(`Please fill all the * required fields!`);
        toast.error("Please fill your Campaign Name!");
      } /* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } */ else if (
        (urlPrefix === "text" && sourceText === "") ||
        (urlPrefix !== "text" && sourceUrl === "")
      ) {
        toast.error("Please fill your Source Page URL/TEXT");
      } else if (video && !videoTag) {
      /* else if (!paymentOption) {
                toast.error('Please choose the payment option!');
                return;
            }  */ /* else if (!autoPublish) {
                toast.error('Please fill the autopublish blog!');
            } */
        toast.error("Please enter YouTube video URL on video section");
      } else if (video && !youtubeMatch) {
        toast.error("Please enter only YouTube video URL");
      } else {
      /* else if (!name) {
                toast.error('Please fill the required field on author section!');
            } */
        try {
          var tmpurl =
            urlPrefix === "https://"
              ? (document.getElementById("sourceurl") as HTMLInputElement)
                  ?.value
              : "";
          if (tmpurl.indexOf("http") < 0)
            tmpurl = urlPrefix === "https://" ? "https://" + tmpurl : "";

          const finalurl = tmpurl;
          const youtubeMatch = finalurl?.match(
            /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
          );

          setIsLoadingGetPage(true);
          const videoid = youtubeMatch ? youtubeMatch[1] : "";

          const response = await createCampaignMutation({
            campaign_name: campaignName,
            url: finalurl ? encodeURIComponent(finalurl) : "",
            email: user_email || getCookie("user_email") || "",
            sourcemode: urlPrefix === "text" ? "text" : "url",
            videoid: videoid ? videoid : "",
            product_desc: sourceText ? encodeURIComponent(sourceText) : "",
          });
          console.log("response==" + response);

          if ("data" in response) {
            console.log("created campaign result=>", response.data); //getting campaign id here
            if (response.data.status === "success") {
              setCampaignId(response.data.campaign_id);
              autoPublishCheck(response.data.campaign_id);
              handleUpdateSetting(response.data.campaign_id);
              handleVerifyCheckClick(response.data.campaign_id);
              toast.success(response.data.msg);
              setIsLoadingGetPage(false);
              localStorage.setItem("fromNewcampaign", "true");
              handleCheckout(response.data.campaign_id);
              // setOpenPaymentInstructModal(true);
            } else if (response.data.status === "failed") {
              setIsLoadingGetPage(false);
              toast.error(response.data.msg);
            }
          } else {
            const errorMessage = (response?.error as any)?.data?.detail as
              | string
              | undefined;

            toast.error(errorMessage);
            setIsLoadingGetPage(false);
            //window.location.reload();
          }
        } catch (error) {
          setIsLoadingGetPage(false);
          console.log("Error creating campaign:", error);
        }
      }
    }
  };

  const handleTextChange = (event: any) => {
    let inputText = event.target.value;
    setUserBusinessText(inputText);
  };

  useEffect(() => {
    let intervalId: any;
    if (isloadingGetPage && loaderProgress < 100) {
      intervalId = setInterval(() => {
        setLoaderProgress((prevProgress: any) => {
          const newProgress = prevProgress + 2;
          return newProgress >= 98 ? 98 : newProgress;
        });
      }, intervaltime);
    }

    return () => clearInterval(intervalId);
  }, [isloadingGetPage, loaderProgress]);

  /*** code for celery starts */
  interface TaskStatusResponse {
    state: "pending" | "done" | "error";
    result?: any;
    message?: string;
  }

  interface ScrapPageResponse {
    task_id: string;
  }

  // Utility to sleep for some ms
  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const waitForTaskResult = async (
    taskId: string,
    apiUrl: string,
  ): Promise<any> => {
    const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;

    while (true) {
      const { data } = await axios.get<TaskStatusResponse>(statusUrl);

      if (data.state === "done") {
        const statusUrl1 = `${apiUrl}/api/prompts/kill_celery_task?task_id=${taskId}`;
        const res = await axios.get<TaskStatusResponse>(statusUrl1);

        return data.result;
      } else if (data.state === "error") {
        throw new Error(data.message || "Task failed");
      }

      await sleep(2000); // poll every 2 seconds
    }
  };

  /*** code for celery ends */

  const handlescrappage = async (url: string) => {
    setIsLoadingGetPage(true);
    setLoaderProgress(4);
    // setIsScrapcheckloading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      // const response = await axios.get(
      //     `${apiUrl}/api/prompts/scrap_page?url=${url}`,
      // );

      // Step 1: start the task
      const { data } = await axios.get<ScrapPageResponse>(
        `${apiUrl}/api/prompts/scrap_page?url=${encodeURIComponent(url)}`,
      );
      const taskId = data.task_id;

      // Step 2: poll until done
      const response = await waitForTaskResult(taskId, apiUrl);

      console.log("scrap_page response=>", response);

      if (response.result === "failed") {
        setIsLoadingGetPage(false);
        toast.error(response.data);
      } else {
        handleCreateCampaignClick();
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setIsScrapcheckloading(false);
      setLoaderProgress(15);
    }
  };

  useEffect(() => {
    console.log(campaignId);
  }, [campaignId]);

  const handleCreateCampaignClick = async () => {
    console.log("fromedit=>", FromEdit);
    console.log("campId=>", campIdFrEdit);
    if (
      FromEdit === "startEditing" ||
      localStorage.getItem("ChangepayMode") === "true"
    ) {
      /*  if (video && !videoTag) {
                 toast.error('Please enter YouTube video URL on video section');
             } else if (video && !youtubeMatch) {
                 toast.error('Please enter only YouTube video URL');
 
             } else { */
      autoPublishCheck(campIdFrEdit);
      handleUpdateSetting(campIdFrEdit);
      localStorage.removeItem("ChangepayMode");
      localStorage.removeItem("IdChangingMode");
      // }
      // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
      // if(planDetails?.owndomain === '1'){

      // }
    } else {
      // debugger;
      // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
      /*  if (campaignName === '') {
                toast.error('Please fill your Campaign Name!');
            }  */ /* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } */ /*  else */ /* if (
        (urlPrefix === "text" && userBusinessText === "") ||
        (urlPrefix === "https://" && sourceUrl === "") ||
        (urlPrefix === "youtubeid" && sourceYoutubeUrl === "") ||
        (urlPrefix === "upload" && !uploadedvideopath)
      ) {
        toast.error("Please fill any one of the source type!");
      } else */ if (
        (sourceUrl || userBusinessText) &&
        blogcount > planDetails?.blog_count_balance
      ) {
        setUpgradeModal(true);
        // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
      } else if (
        (sourceYoutubeUrl || uploadedvideopath) &&
        blogcount > planDetails?.podcast_count_balance
      ) {
        setUpgradeModal(true);
        // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
      } else {
      /* else if (!paymentOption) {
                toast.error('Please choose the payment option!');
                return;
            } */ /* else if (!autoPublish) {
                toast.error('Please fill the autopublish blog!');
            } */ /* else if (video && !videoTag) {
                toast.error('Please enter YouTube video URL on video section');
            } */ /* else if (video && !youtubeMatch) {
                toast.error('Please enter only YouTube video URL');

            } */
      /* else if (!name) {
                toast.error('Please fill the required field on author section!');
            } */
        try {
          var tmpurl =
            urlPrefix === "youtubeid"
              ? (
                  document.getElementById(
                    "sourceyoutubeurl",
                  ) as HTMLInputElement
                )?.value
              : "";
          if (tmpurl.indexOf("http") < 0)
            tmpurl = urlPrefix === "youtubeid" ? "https://" + tmpurl : "";

          const finalurl = tmpurl;
          /* const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    ); */
          const youtubeMatch = finalurl?.match(
            /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/,
          );
          const videoid = youtubeMatch ? youtubeMatch[1] : "";
          if ((!videoid || videoid === "") && urlPrefix === "youtubeid") {
            toast.error("Not a valid Url");
          } else {
            setLoadingText(
              <Typography fontSize="18px">
                <b>Analyzing Your Content</b>
                <br />
                We’re using AI Agents to read through your content, analyze your
                content, and will suggest some ideas that we can write about
              </Typography>,
            );
            setLoaderProgress(15);
            setIsLoadingGetPage(true);
            const formData = new FormData();
            // formData.append('campaign_name', campaignName);
            formData.append("email", user_email);
            formData.append(
              "sourcemode",
              urlPrefix === "text"
                ? "text"
                : urlPrefix === "https://"
                  ? "url"
                  : urlPrefix === "youtubeid"
                    ? "youtube"
                    : urlPrefix === "upload"
                      ? "upload"
                      : urlPrefix === "word"
                        ? "docx"
                        : "pdf",
            );
            formData.append("url", sourceUrl);
            formData.append("videoid", videoid);
            formData.append(
              "product_desc",
              urlPrefix === "word" || urlPrefix === "pdf"
                ? uploadedvideopath
                : userBusinessText,
            );
            formData.append(
              "media_file_path",
              urlPrefix === "word" || urlPrefix === "pdf"
                ? ""
                : uploadedvideopath,
            );
            formData.append("blog_count", blogcount);
            formData.append("toc", `${toc ? 1 : 0}`);
            formData.append("external_links", `${externalLinks ? 1 : 0}`);
            formData.append("callmode", "");

            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
            const response = await axios.post(
              `${apiUrl}/api/prompts/create_campaign`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            );
            console.log("create campaign data=>", response);
            if (response.data.status === "success") {
              setLoaderProgress(40);
              const campID = response.data.campaign_id;
              setCampaignId(response.data.campaign_id);
              autoPublishCheck(response.data.campaign_id);
              handleUpdateSetting(response.data.campaign_id);
              localStorage.setItem("fromNewcampaign", "true");
              try {
                // setIsLoadingGetPage(true);
                const formData = new FormData();
                formData.append("userid", user_email);
                formData.append("url", sourceUrl);
                formData.append(
                  "product_desc",
                  urlPrefix === "word" || urlPrefix === "pdf"
                    ? uploadedvideopath
                    : userBusinessText,
                );
                formData.append("tone", "");
                formData.append(
                  "sourcemode",
                  urlPrefix === "text"
                    ? "text"
                    : urlPrefix === "https://"
                      ? "url"
                      : urlPrefix === "youtubeid"
                        ? "youtube"
                        : urlPrefix === "upload"
                          ? "upload"
                          : urlPrefix === "word"
                            ? "docx"
                            : "pdf",
                );
                formData.append("videoid", videoid);
                formData.append(
                  "media_file_path",
                  urlPrefix === "word" || urlPrefix === "pdf"
                    ? ""
                    : uploadedvideopath,
                );
                formData.append("campaignid", campID);

                const apiUrl: string =
                  process.env.REACT_APP_SERVER_ENDPOINT || "";

                // const response = await axios.post(
                //     `${apiUrl}/api/prompts/create_topics?title_count=${10}`,
                //     formData,
                //     {
                //         headers: {
                //             'Content-Type': 'multipart/form-data',
                //         },
                //     }
                // );

                // Step 1: Initiate the task
                const { data } = await axios.post<{ task_id: string }>(
                  `${apiUrl}/api/prompts/create_topics?title_count=10`,
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  },
                );

                const taskId = data.task_id;

                // Step 2: poll until done
                const response1 = await waitForTaskResult(taskId, apiUrl);

                console.log("create topics response=>", response1);
                if (response1.result === "success") {
                  setLoaderProgress(100);
                  await new Promise((resolve) => setTimeout(resolve, 500));
                  setIsLoadingGetPage(false);
                  setTopics(response1.data);
                  setTopicsList(true);
                } else if (response1.result !== "success") {
                  toast.error(response1.message);
                }
              } catch (error) {
                console.log("Error fetching topics=>", error);
              } finally {
                setIsLoadingGetPage(false);
              }
              // handleGetPageforCampaign(response.data.campaign_id);
            } else if (response.data.result === "fail") {
              setIsLoadingGetPage(false);
              toast.error(response.data.message);
            }
          }
        } catch (error) {
          setIsLoadingGetPage(false);
          console.log("Error creating campaign:", error);
        }
      }
    }
  };

  useEffect(() => {
    if (FromEdit === "startEditing") {
      getVerifyingScript(campIdFrEdit);
      handleVerifyCheckClick(campIdFrEdit);
      cnameRec(campIdFrEdit);
    }
  }, []);

  const cnameRec = async (campIdFrEdit: string) => {
    try {
      const response = await getCnameEntriesMutation({
        email: user_email || getCookie("user_email") || "",
        campaignid: campIdFrEdit || "",
      });
      if ("data" in response) {
        console.log("cnameentries=>", response.data.cnamerecords);
        setCnameDomainName(response.data);
        setCnameRecords(response.data.cnamerecords);
      }
    } catch (error) {
      console.log("Error fetching dns record:", error);
    }
  };

  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({
        email: user_email || getCookie("user_email") || "",
        campaignid:
          /* campIdFrEdit || localStorage.getItem('IdChangingMode') ||  */ "",
      });
      if ("data" in response) {
        setPlanDetails(response.data.data);
        //console.log('plan details***=>', response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* const fetchDefaultPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({ email: user_email, campaignid: '' });
            if ('data' in response) {

                setDefaultPlanDetails(response.data.data);
                console.log('default plan details***=>', response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    } */

  useEffect(() => {
    // if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' || successCancelSubscription === true) {
    fetchPlanDatas();
    //console.log(planDetails);
    // }
  }, []);

  const fetchCampDatas = async () => {
    try {
      const response = await getuserCampDetails({
        campaignid:
          campIdFrEdit || /* localStorage.getItem('IdChangingMode') || */ "",
      });
      if ("data" in response) {
        setCampDetails(response.data.data);
        console.log("camp details***=>", response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (FromEdit === "startEditing") {
      fetchCampDatas();
    }
  }, []);

  /* useEffect(() => {

        fetchDefaultPlanDatas();

    }, []); */

  const autoPublishCheck = async (id: string) => {
    setIsUpdateLoader(true);
    try {
      const validVideoTag =
        videoTag?.trim() || campDetails?.videotag?.trim() || "";
      const response = await updateAutoPublishCheckMutation({
        campaign_id: id,
        autopublish: autoPublish ? 1 : 0,
        threeblogperday: limitPublish ? 1 : 0,
        addtags: addtags ? 1 : 0,
        capturleads: capturleads ? 1 : 0,
        twitterurl: planDetails?.twitterurl || twitterUrl || "",
        fburl: planDetails?.fburl || fbUrl || "",
        pintresturl: planDetails?.pintresturl || pintrestUrl || "",
        linkedinurl: planDetails?.linkedinurl || linkedinUrl || "",
        newsletter: newsletter ? 1 : 0,
        twitternbutton: twitternbutton ? 1 : 0,
        fbbutton: fbbutton ? 1 : 0,
        pintrestbutton: /* pintrestbutton ? 1 : */ 0,
        linkedinbutton: linkedinbutton ? 1 : 0,
        video: video ? 1 : 0,
        owndomain: useOwnDomain ? 1 : 0,
        cta_lable: ctaLabel
          ? encodeURIComponent(ctaLabel)
          : planDetails?.cta_lable
            ? encodeURIComponent(planDetails?.cta_lable)
            : "Learn More",
        cta_link: ctaLink
          ? encodeURIComponent(ctaLink)
          : campDetails?.cta_link
            ? encodeURIComponent(campDetails?.cta_link)
            : sourceUrl,
        videotag: encodeURIComponent(validVideoTag),
        iframe: 1,
        publish_to_ocesha: publishToOcesha ? 1 : 0,
        publish_to_code_genie: publishToCodegenie ? 1 : 0,
        competetor_search: competitorSearch ? 1 : 0,
      });
      console.log(response);
      if (FromEdit === "startEditing") {
        if ("data" in response) {
          console.log(response.data.msg);

          // toast.success(response.data.msg);
          if (FromEdit === "startEditing") {
            toast.success("Blog settings updated successfully!");
          } else {
            toast.success(response.data.msg);
          }
        }
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setIsUpdateLoader(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await getUserDetailsMutation({
        email: user_email || getCookie("user_email") || "",
        filter: "",
        start_date: "",
        end_date: "",
      });

      if ("data" in response) {
        // const datas = response.data.data;
        setUserDetails(response.data.data);
        console.log("userDet =>", response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCheckout = async (campaignId: string) => {
    let referral_param = localStorage.getItem("referral_param");
    localStorage.removeItem("referral_param");
    /* let couponcode = localStorage.getItem("couponcode");
        localStorage.removeItem("couponcode"); */

    try {
      const response = await createCheckoutSession({
        emailid: user_email || getCookie("user_email") || "",
        username: userDetails.name,
        subscription_level:
          selectedSubscriptionLevel /* paymentOption === '$0/mo.' ? 'level_0' : paymentOption === '$14/mo.' ? 'level_1' : paymentOption === '$39/mo.' ? 'level_2' : paymentOption === '$99/mo.' ? 'level_3' : (paymentOption === '$0/mo.' && period === 'yearly') ? 'level_0y' : paymentOption === '$82.5/mo.' ? 'level_4' : paymentOption === '$165.8/mo.' ? 'level_5' : paymentOption === '$249.16/mo.' ? 'level_6' : '' */,
        referral_param: referral_param || "",
        couponcode: couponCode ?? "",
        mode: "",
        campaignid: campaignId || "",
        from_page: "campaign",
        return_domain: "",
      });

      if (response.data.message == "Checkout url created") {
        // Assuming response contains the checkout URL
        const checkoutUrl = response.data.checkout_url;

        // Redirect to the Stripe checkout page
        window.location.href = checkoutUrl;
      } else if (response.data.error) {
        const errorMessage = response.data.error;
        if (
          errorMessage.includes(
            "This promotion code cannot be redeemed because the associated customer has prior transactions.",
          )
        ) {
          toast.error("Coupon code already applied");
        } else if (
          errorMessage.includes(
            "This coupon cannot be redeemed because it does not apply to anything in this order.",
          )
        ) {
          toast.error("Invalid Coupon code");
        } else {
          toast.error("Invalid Coupon code");
        }
      }
      /* else {
                console.log('checkout res=>', response);
                toast.error("Something went wrong, checkout url not created");
            } */
    } catch (e) {
      alert(e);
      console.log(e);
    }
  };

  const data = [
    { heading: "QUANTITY", value: "1" },
    {
      heading: "PLAN TYPE",
      value: period === "monthly" ? "Monthly" : "Yearly",
    },
    {
      heading: "PLAN NAME",
      value: planDetails
        ? planDetails.subscription_level === "level_0" ||
          planDetails.subscription_level === "level_0y"
          ? "Starter"
          : planDetails.subscription_level === "level_1" ||
              planDetails.subscription_level === "level_4"
            ? "Basic"
            : planDetails.subscription_level === "level_2" ||
                planDetails.subscription_level === "level_5"
              ? "Pro"
              : planDetails.subscription_level === "level_3" ||
                  planDetails.subscription_level === "level_6"
                ? "Traffic Hacker"
                : ""
        : selectedSubscriptionLevel
          ? selectedSubscriptionLevel === "level_0" ||
            selectedSubscriptionLevel === "level_0y"
            ? "Starter"
            : selectedSubscriptionLevel === "level_1" ||
                selectedSubscriptionLevel === "level_4"
              ? "Basic"
              : selectedSubscriptionLevel === "level_2" ||
                  selectedSubscriptionLevel === "level_5"
                ? "Pro"
                : selectedSubscriptionLevel === "level_3" ||
                    selectedSubscriptionLevel === "level_6"
                  ? "Traffic Hacker"
                  : ""
          : "",
    },
    {
      heading: "TOTAL",
      value: planDetails
        ? planDetails?.subscription_level === "level_0"
          ? "$49/mo."
          : planDetails?.subscription_level === "level_1"
            ? "$99/mo."
            : planDetails?.subscription_level === "level_2"
              ? "$199/mo."
              : planDetails?.subscription_level === "level_3"
                ? "$299/mo."
                : planDetails?.subscription_level === "level_0y"
                  ? "$" + (48.8 * 12).toFixed(1) + "/yr."
                  : planDetails?.subscription_level === "level_4"
                    ? "$" + (82.5 * 12).toFixed(1) + "/yr." /* '$82.5/mo.' */
                    : planDetails?.subscription_level === "level_5"
                      ? "$" +
                        (165.8 * 12).toFixed(1) +
                        "/yr." /* '$165.8/mo.' */
                      : planDetails?.subscription_level === "level_6"
                        ? "$" +
                          (249.16 * 12).toFixed(1) +
                          "/yr." /* '$249.16/mo.' */
                        : ""
        : /* paymentOption */ paymentOptYearlyCal,
    },
    // { heading: 'PAYMENT', value: <Button variant="contained" sx={{ color: '#fff' }} onClick={handleCheckout}>Pay Now</Button> }
  ];

  /* const configureData = cnameRecords && cnameRecords.map((record: any) =>
        [
            { heading: 'DOMAIN NAME', value: 'MyDomain.com' },
            { heading: 'RECORD TYPE', value: 'CNAME' },
            {
                heading: 'HOST NAME', value: <TextField variant="outlined" sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#9FADBC',
                        },
                        '&:hover fieldset': {
                            borderColor: '#9FADBC',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#9FADBC',
                        },
                        height: 30,
                        marginBottom: '-6%'
                    },
                }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    edge="end"
                                    size="small"
                                    sx={{
                                        marginRight: '8px',
                                        background: '#000',
                                        borderRadius: '3px',
                                        padding: '5%',
                                        width: '140%',
                                        fontSize: '10px',
                                        '&:hover': {
                                            background: '#000', // Optional: Add hover effect for better UX
                                        },
                                    }}
                                //   onClick={() => handleCopyName(record.name)}
                                >
                                    Copy
                                </IconButton>
                            </InputAdornment>
                        ),
                    }} value={record.name}></TextField>
            },
            {
                heading: 'REQUIRED VALUE', value: <TextField variant="outlined" sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#9FADBC',
                        },
                        '&:hover fieldset': {
                            borderColor: '#9FADBC',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#9FADBC',
                        },
                        height: 30,
                        marginBottom: '-6%'
                    },
                }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    edge="end"
                                    size="small"
                                    sx={{
                                        marginRight: '8px',
                                        background: '#000',
                                        borderRadius: '3px',
                                        padding: '5%',
                                        width: '140%',
                                        fontSize: '10px',
                                        '&:hover': {
                                            background: '#000', // Optional: Add hover effect for better UX
                                        },
                                    }}
                                //   onClick={() => handleCopyVal(record.value)}
                                >
                                    Copy
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    value={record.value}></TextField>
            },
            { heading: 'VERIFY', value: record.verified === true ? <div style={{ border: '1px solid #027A48', borderRadius: '20px', padding: '5%', textAlign: 'center', background: '#A6F4C5' }}><span style={{ color: '#027A48', fontWeight: 'bold', fontSize: '16px' }}><VerifiedIcon />Verified</span></div> : <div style={{ border: '1px solid #D43131', borderRadius: '20px', padding: '5%', textAlign: 'center' }}><span style={{ color: '#D43131', fontWeight: 'bold', fontSize: '16px' }}>Non-verified</span></div> }
        ]
    ) */

  const handledropdownChange = (event: any) => {
    setSelectedSection(event.target.value);
  };

  const handleSourceUrlChange = (event: any) => {
    let urlVal = event.target.value;
    if (urlVal.startsWith("https://")) {
      urlVal = urlVal.replace("https://", "");
    }

    const element = document.getElementById("authurl") as HTMLInputElement;
    setSourceUrl(urlVal);
    localStorage.setItem("sourceurl", urlVal);
    if (element && !socialUrl) {
      element.value = urlVal;
      setSocialUrl(urlVal);
    }
  };

  const handleblogscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setBlogCount(value);
    } else {
      toast.error("Please enter numeric value!");
    }
  };

  const handleSourceYoutubeUrlChange = (event: any) => {
    let urlVal = event.target.value;
    if (urlVal.startsWith("https://")) {
      urlVal = urlVal.replace("https://", "");
    }

    const element = document.getElementById("authurl") as HTMLInputElement;
    setSourceYoutubeUrl(urlVal);
    if (element && !socialUrl) {
      element.value = urlVal;
      setSocialUrl(urlVal);
    }

    // localStorage.setItem('sourceurl', urlVal);
  };

  const handleSourceTextChange = (event: any) => {
    let textVal = event.target.value;
    setSourceText(textVal);
    localStorage.setItem("sourcetext", textVal);
  };

  const handlePodcastUrlChange = (event: any) => {
    let podcastVal = event.target.value;
    setPodcastOrYoutubeUrl(podcastVal);
    localStorage.setItem("podcastUrl", podcastVal);
  };

  /* useEffect(() => {
        if (sourceYoutubeUrl) {
            setVideoTag(sourceYoutubeUrl);
        } else if (planDetails?.videotag) {
            setVideoTag(planDetails?.videotag);
        } else if (planDetails?.videoid && !videoTag) {
            setVideoTag(`https://www.youtube.com/watch?v=${planDetails.videoid}`);
        }
    }, [planDetails, sourceUrl]); */

  useEffect(() => {
    if (sourceYoutubeUrl) {
      setVideoTag(sourceYoutubeUrl);
    }
  }, [sourceYoutubeUrl]);

  const handlevideotag = (event: any) => {
    let videotagg = event.target.value.trim();
    setVideoTag(videotagg);
    /* if (sourceYoutubeUrl) {
            setSourceYoutubeUrl(videotagg);
        } else */ if (campDetails) {
      setCampDetails({
        ...campDetails,
        videotag: videotagg,
      });
    }
    localStorage.setItem("videoTag", videotagg);
  };

  const handletwitterUrlChange = (event: any) => {
    let urlVal = event.target.value;
    settwitterUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        twitterurl: urlVal,
      });
    }
    localStorage.setItem("twitterurl", urlVal);
  };

  const handlefbUrlChange = (event: any) => {
    let urlVal = event.target.value;
    setfbUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        fburl: urlVal,
      });
    }
    localStorage.setItem("fburl", urlVal);
  };

  const handlepintrestUrlChange = (event: any) => {
    let urlVal = event.target.value;
    setPintrestUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        pintresturl: urlVal,
      });
    }
    localStorage.setItem("pintresturl", urlVal);
  };

  const handleCtaLabelChange = (event: any) => {
    let label = event.target.value;
    setCtaLabel(label);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        cta_lable: label,
      });
    }
  };

  const handleCtaLinkChange = (event: any) => {
    let link = event.target.value;
    setCtaLink(link);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        cta_link: link,
      });
    }
  };

  const handlelinkedinUrlChange = (event: any) => {
    let urlVal = event.target.value;
    setLinkedinUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        linkedinurl: urlVal,
      });
    }
    localStorage.setItem("linkedinurl", urlVal);
  };

  const handlepaymentOptions = (value: any, subscription_level: any) => {
    // const payment_Option = event?.target.value;
    setPaymentOption(value);
    setSelectedSubscriptionLevel(subscription_level);
    console.log("selecting subscription=>", selectedSubscriptionLevel);
    console.log("selected payment val=>", paymentOption);
    setPaymentOptYearlyCal(
      value === "$48.8/mo." && period === "yearly"
        ? "$" + (48.8 * 12).toFixed(1) + "/yr."
        : value === "$82.5/mo."
          ? "$" + (82.5 * 12).toFixed(1) + "/yr."
          : value === "$165.8/mo."
            ? "$" + (165.8 * 12).toFixed(1) + "/yr."
            : value === "$249.16/mo."
              ? "$" + (249.16 * 12).toFixed(1) + "/yr."
              : value,
    );
    localStorage.setItem("paymentOption", value);
    localStorage.setItem("PaymentSubscription", subscription_level);

    if (
      subscription_level == "level_0" ||
      subscription_level == "level_0y" ||
      subscription_level == "level_1" ||
      subscription_level == "level_2" ||
      subscription_level == "level_4" ||
      subscription_level == "level_5"
    ) {
      setExpanded3(false);
      setExpanded6(false);
      setExpanded7(false);
      setExpanded8(false);
      setExpanded9(false);

      setSocialMediaUrlPublish(false);
      setCapturLeads(false);
      setNewsLetter(false);
      setTwitternButton(false);
      setFbButton(false);
      setPintrestButton(false);
      setLinkedinButton(false);

      settwitterUrl("");
      setfbUrl("");
      setPintrestUrl("");
      setLinkedinUrl("");
    } else {
      setCapturLeads(true);
      setNewsLetter(true);
      setTwitternButton(true);
      setFbButton(true);
      setPintrestButton(true);
      setLinkedinButton(true);
    }
  };

  const paymentSubscription = localStorage.getItem("PaymentSubscription") || "";

  /* const handlepaymentOptions1 = (event: any) => {
        const payment_Option = event?.target.value;
        setPaymentOption(payment_Option);
        localStorage.setItem('paymentOption', payment_Option);
    }

    const handlepaymentOptions2 = (event: any) => {
        const payment_Option = event?.target.value;
        setPaymentOption(payment_Option);
        localStorage.setItem('paymentOption', payment_Option);
    }

    const handlepaymentOptions3 = (event: any) => {
        const payment_Option = event?.target.value;
        setPaymentOption(payment_Option);
        localStorage.setItem('paymentOption', payment_Option);
    }

    const handlepaymentOptions4 = (event: any) => {
        const payment_Option = event?.target.value;
        setPaymentOption(payment_Option);
        localStorage.setItem('paymentOption', payment_Option);
    }

    const handlepaymentOptions5 = (event: any) => {
        const payment_Option = event?.target.value;
        setPaymentOption(payment_Option);
        localStorage.setItem('paymentOption', payment_Option);
    } */

  const handleAutoPublishChange = (event: any) => {
    const isChecked = event.target.checked;
    setAutopublish(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        autopublish: isChecked,
      });
    }
    localStorage.setItem("autoPublish", isChecked.toString());
  };

  const handlePublishToOceshaChange = (event: any) => {
    const isChecked = event.target.checked;
    setPublishToOcesha(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        publish_to_ocesha: isChecked,
      });
    }
    localStorage.setItem("publish_to_ocesha", isChecked.toString());
  };

  const handleCompetitorSearchChange = (event: any) => {
    const isChecked = event.target.checked;
    setCompetitorSearch(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        competetor_search: isChecked,
      });
    }
    localStorage.setItem("competitor_search", isChecked.toString());
  };

  const handlePublishToCodegenieChange = (event: any) => {
    const isChecked = event.target.checked;
    setPublishToCodegenie(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        publish_to_code_genie: isChecked,
      });
    }
    localStorage.setItem("publish_to_code_genie", isChecked.toString());
  };

  const handlelimitPublishChange = (event: any) => {
    const isChecked = event.target.checked;
    setLimitPublish(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        threeblogperday: isChecked,
      });
    }
    localStorage.setItem("limitPublish", isChecked.toString());
  };

  const handlesocialMediaUrlPublishChange = (event: any) => {
    /* if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                return false;
            } */
    const isChecked = event.target.checked;
    setSocialMediaUrlPublish(isChecked);
    if (campDetails) {
      // Update planDetails if it exists (you can add specific updates if needed)
      setCampDetails({
        ...campDetails,
        // Here you can add any relevant updates to planDetails based on isChecked
        // For example:
        socialMediaUrlPublish: isChecked,
      });
    }
    localStorage.setItem("smUrlpublish", isChecked.toString());
  };

  const handleaddtagsChange = (event: any) => {
    const isChecked = event.target.checked;
    setAddTags(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        addtags: isChecked,
      });
    }
    localStorage.setItem("addTags", isChecked.toString());
  };

  const handletocChange = (event: any) => {
    const isChecked = event.target.checked;
    setToc(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        toc: isChecked,
      });
    }
    localStorage.setItem("toc", isChecked.toString());
  };

  const handleexternalLinksChange = (event: any) => {
    const isChecked = event.target.checked;
    setExternalLinks(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        external_links: isChecked,
      });
    }
    localStorage.setItem("externalLinks", isChecked.toString());
  };

  const handlecapturleadsChange = (event: any) => {
    const isChecked = event.target.checked;
    setCapturLeads(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        capturleads: isChecked,
      });
    }
    localStorage.setItem("captureLeads", isChecked.toString());
  };

  const handlenewsletterChange = (event: any) => {
    const isChecked = event.target.checked;
    setNewsLetter(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        newsletter: isChecked,
      });
    }
    localStorage.setItem("newsLetter", isChecked.toString());
  };

  const handletwitterBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setTwitternButton(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        twitternbutton: isChecked,
      });
    }
    localStorage.setItem("twitterBtn", isChecked.toString());
  };

  const handlefbBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setFbButton(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        fbbutton: isChecked,
      });
    }
    localStorage.setItem("fbBtn", isChecked.toString());
  };

  const handlepintrestBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setPintrestButton(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        pintrestbutton: isChecked,
      });
    }
    localStorage.setItem("pintrestBtn", isChecked.toString());
  };

  const handlelinkedinBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setLinkedinButton(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        linkedinbutton: isChecked,
      });
    }
    localStorage.setItem("linkedinBtn", isChecked.toString());
  };

  const handlevideoChange = (event: any) => {
    const isChecked = event.target.checked;
    setVideo(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        video: isChecked,
      });
    }
    localStorage.setItem("video", isChecked.toString());
  };

  const handleOwnDomainChange = (event: any) => {
    const isChecked = event.target.checked;
    setUseOwnDomain(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        owndomain: isChecked,
      });
    }
    localStorage.setItem("owndomain", isChecked.toString());
  };

  const handleAuthorUseDefaultChange = (event: any) => {
    const isChecked = event.target.checked;
    setUseAsDefault(isChecked);
    // if (userDetails) {
    //     setUserDetails({
    //         ...userDetails,
    //         blog_default: isChecked
    //     })
    // }
    // else
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        use_as_default: isChecked,
      });
    } else if (userDetails) {
      setUserDetails({
        ...userDetails,
        blog_default: isChecked,
      });
    }
    localStorage.setItem("authorDefaultCheck", isChecked.toString());
  };

  const handleModalPayNowClick = () => {
    setOpenPaymentInstructModal(false);
    setExpanded(true);
    setTimeout(() => {
      paymentSectionRef?.current?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  const campaignIdfromsuccess = localStorage.getItem("campaignid");

  const handleTopicConfirmation = async (
    topic: any,
    keywordCount: any,
    campId: any,
  ) => {
    setIsLoadingGetPage(true);
    setLoaderProgress(8);
    setLoadingText(
      <Typography fontSize="18px">
        <b>Researching Keywords</b>
        <br />
        We’re using AI Agents to research and suggest the best keywords to get
        traffic for your blog
      </Typography>,
    );
    setTopicsList(false);
    setIsKeywordLoader(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.get(
        `${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`,
      );

      if (response.data.result) {
        setLoaderProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 500));
        setIsLoadingGetPage(false);
        setKeywords(response.data.data);
        setKeywordsList(true);
        setTopicsList(false);
      }

      // Step 1: start the task
      // const { data } = await axios.get<ScrapPageResponse>(`${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`);
      // const taskId = data.task_id;

      // // Step 2: poll until done
      // const response2 = await waitForTaskResult(taskId, apiUrl);

      // console.log('keywords response=>', response2);
      // if (response2.result) {
      //     setLoaderProgress(100);
      //     await new Promise(resolve => setTimeout(resolve, 500));
      //     setIsLoadingGetPage(false);
      //     setKeywords(response2.data);
      //     setKeywordsList(true);
      //     setTopicsList(false);
      // }
    } catch (error) {
      console.log("Error fetching keywords=>", error);
    } finally {
      setIsKeywordLoader(false);
      setLoaderProgress(40);
      setIsLoadingGetPage(false);
    }
  };

  const handleGetPageforCampaign = async (
    userEmail: any,
    campaignid: any,
    topic: any,
    keyword: any,
  ) => {
    setKeywordsList(false);
    setIsLoadingGetPage(true);
    setLoaderProgress(8);
    // if (!campIdFrEdit) {
    setLoadingText(
      <Typography fontSize="18px">
        <b>Writing Blog Content</b>
        <br />
        Our AI is now writing your blog(s) based on your content, topic, and
        keyword. We will use Google EEAT standard that will help with your blog
        ranking well in Google Search.
      </Typography>,
    );
    setIntervalTime(4000);
    // setIsLoadingGetPage(true);
    // }
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

      //const response = await getPageforCampaign({ email: userEmail || getCookie('user_email') || "", campaign_id: campaignid || '', topic: topic, keywords: keyword });

      // Step 1: Call the mutation to start the task
      const { data: taskResponse }: any = await getPageforCampaign({
        email: userEmail || getCookie("user_email") || "",
        campaign_id: campaignid || "",
        topic,
        keywords: keyword,
      });

      const taskId = taskResponse.task_id;

      // Step 2: Poll until task is done or failed
      const response = await waitForTaskResult(taskId, apiUrl);

      console.log("response-------------");
      console.log(response);
      if ("data" in response) {
        //console.log('getpagecampaign=>', response.data.result);
        console.log("campIdFrEdit-------", campIdFrEdit);

        if (response.result === "success" && !campIdFrEdit) {
          setLoaderProgress(100);
          setTimeout(() => {
            localStorage.setItem("activeItem", "blogs");
            setIsLoadingGetPage(false);
            navigate("/codegenie/generated-blogs", {
              state: { FromCampaign: campaignIdfromsuccess },
            });
            // setOpenGetPageSuccessModal(true);
          }, 1000);
        } else if (response.result === "failure") {
          setGetPageError(true);
          toast.error(response.message);
        }
      } else {
        const errorMessage = (response?.error as any)?.data?.detail as
          | string
          | undefined;
        toast.error(errorMessage);
        setIsLoadingGetPage(false);
      }
    } catch (error) {
      toast.error("Error generating blogs");
      setIsLoadingGetPage(false);
      console.log("Error generating blogs:", error);
    }
  };

  /* useEffect(() => {
        if (campaignIdfromsuccess && !getpageRunref.current) {
            handleGetPageforCampaign();
            getpageRunref.current = true;
        }
    }, [campaignIdfromsuccess]) */

  const handleGetPageModalClose = async () => {
    setOpenGetPageSuccessModal(false);
    localStorage.setItem("activeItem", "blogs");
    navigate("/codegenie/generated-blogs", {
      state: { FromCampaign: campaignIdfromsuccess },
    });
    // setExpanded3(true);
    // setTimeout(() => {
    //    getcnameEntriesRef?.current?.scrollIntoView({ behavior: 'smooth' });
    // }, 300);
    setIsLoadingCnameRec(true);
    // try {
    //    const response = await getCnameEntriesMutation({ email: user_email, campaignid: campaignIdfromsuccess || '' });
    //   if ('data' in response) {
    //      console.log('cnameentries=>', response.data.cnamerecords);
    //      setCnameDomainName(response.data);
    //    setCnameRecords(response.data.cnamerecords);
    //   }
    //  } catch (error) {
    //    console.log('Error fetching dns record:', error);
    // } finally {
    //     setIsLoadingCnameRec(false);
    //    getVerifyingScript(campaignIdfromsuccess || '');
    //    // localStorage.removeItem('campaignid');
    //  }
  };

  const getVerifyingScript = async (campaignId: string) => {
    // setExpanded4(true);
    /*  setTimeout(() => {
             getVerifyScript?.current?.scrollIntoView({ behavior: 'smooth' });
         }, 300); */
    try {
      const response = await getverifyscript({
        userid: user_email || getCookie("user_email") || "",
        campaingid:
          campaignId ||
          "" /* campaignId ? campaignId : campaignIdfromsuccess || '' */,
      });
      if ("data" in response) {
        console.log("cnameentries=>", response.data.script);
        setScript(response.data.script);
      }
    } catch (error) {
      console.log("fetching error", error);
    }
  };

  const handleVerifyCheckClick = async (campaignId: string) => {
    try {
      const response = await getcheckverified({
        userid: user_email || getCookie("user_email") || "",
        campaingid: campaignId /* localStorage.getItem('campaignid') */ || "",
      });
      if ("data" in response) {
        console.log("cnameentries=>", response.data.status);
        setVerifyCheck(response.data.status);
        localStorage.removeItem("campaignid");
      }
    } catch (error) {
      console.log("fetching error", error);
    }
  };

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      setUserImage(file /* e.target.files[0] */);
      setUserImageUrl(imageUrl);

      return () => URL.revokeObjectURL(imageUrl);
    }
  };

  const handleUpdateSetting = async (campaignId: string) => {
    // e.preventDefault();
    setIsUpdateLoader(true);
    let formData = new FormData();

    // let isFormValid = validateForm();
    // if (isFormValid) {
    //   setIsLoading(true);

    formData.append(
      "name",
      name != "" && name != undefined
        ? name
        : planDetails?.name === undefined
          ? userDetails?.name
          : planDetails.name /* planDetails?.name || '' */,
    );
    formData.append("campaignid", campaignId);
    if (userImage) {
      formData.append("user_image", userImage);
    }

    const element = document.getElementById("authurl") as HTMLInputElement;

    if (element.value) {
      formData.append("social_url", element.value);
    } else {
      formData.append("social_url", socialUrl);
    }

    const element1 = document.getElementById("usedefault") as HTMLInputElement;
    if (element1.checked) {
      formData.append("use_as_default", "1");
    } else {
      formData.append("use_as_default", useAsDefault ? "1" : "0");
    }

    //   formData.append('blog_default', blogDefault ? '1' : '0');
    //   formData.append('email', useremail);
    //   formData.append('auto_publish', isChecked ? `${isChecked}` : "0");
    /* if (!name || !campaignId) {
            toast.error('Please fill the required field on author section!');
        } */
    // else {
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        apiUrl + "/api/prompts/updateAuthorinfo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.data.status == "success") {
        //   toast.success(response.data.message);
        //   setIsLoading(false);
        const randomNumber = Math.random();
        setUserImageUrl(response.data.user_image + "?" + randomNumber);
        /* if (FromEdit === 'startEditing') {
                    toast.success(response.data.message);
                } */
      } else {
        toast.error("Somethng went wrong..");
        //   setIsLoading(false);
      }
      console.log(response.data);
    } catch (error) {
      console.error("Error updating author settings:", error);
      // setIsLoading(false);
    } finally {
      setIsUpdateLoader(false);
    }
    // }

    // }
  };

  useEffect(() => {
    if (campDetails?.social_url) setSocialUrl(campDetails?.social_url);

    if (campDetails?.name) setName(campDetails?.name);

    if (campDetails?.use_as_default == 1) setUseAsDefault(true);
  }, [campDetails]);

  useEffect(() => {
    if (!campDetails?.social_url && userDetails?.social_url)
      setSocialUrl(userDetails?.social_url);

    if (!name) setName(userDetails?.name);
  }, [userDetails]);

  useEffect(() => {
    const storedCampaignName = localStorage.getItem("campaignName");
    if (storedCampaignName) {
      setCampaignName(storedCampaignName);
    }

    const storedAuthorName = localStorage.getItem("Authorname");
    if (storedAuthorName) {
      setName(storedAuthorName);
    }

    const storedAuthorurl = localStorage.getItem("Authorurl");
    if (storedAuthorurl) {
      setSocialUrl(storedAuthorurl);
    }

    const storedSourceUrl = localStorage.getItem("sourceurl");
    if (storedSourceUrl) {
      setSourceUrl(storedSourceUrl);
    }

    const storedSourceText = localStorage.getItem("sourcetext");
    if (storedSourceText) {
      setSourceText(storedSourceText);
    }

    const storedPodcastUrl = localStorage.getItem("podcastUrl");
    if (storedPodcastUrl) {
      setPodcastOrYoutubeUrl(storedPodcastUrl);
    }

    const storedtwitterUrl = localStorage.getItem("twitterurl");
    if (storedtwitterUrl) {
      settwitterUrl(storedtwitterUrl);
    }

    const storedFBUrl = localStorage.getItem("fburl");
    if (storedFBUrl) {
      setfbUrl(storedFBUrl);
    }

    const storedpintrestUrl = localStorage.getItem("pintresturl");
    if (storedpintrestUrl) {
      setPintrestUrl(storedpintrestUrl);
    }

    const storedLinkedinUrl = localStorage.getItem("linkedinurl");
    if (storedLinkedinUrl) {
      setLinkedinUrl(storedLinkedinUrl);
    }

    const payment_opt = localStorage.getItem("paymentOption");
    if (payment_opt) {
      setPaymentOption(payment_opt);
    }

    const storedAutoPublish = localStorage.getItem("autoPublish");
    if (storedAutoPublish !== null) {
      setAutopublish(storedAutoPublish === "true");
    }

    const storedLimitPublish = localStorage.getItem("limitPublish");
    if (storedLimitPublish !== null) {
      setLimitPublish(storedLimitPublish === "true");
    }

    const storedsocialMediaurlsPublish = localStorage.getItem("smUrlpublish");
    if (storedsocialMediaurlsPublish !== null) {
      setSocialMediaUrlPublish(storedsocialMediaurlsPublish === "true");
    }

    const storedAddTags = localStorage.getItem("addTags");
    if (storedAddTags !== null) {
      setAddTags(storedAddTags === "true");
    }

    const storedcaptureLeads = localStorage.getItem("captureLeads");
    if (storedcaptureLeads !== null) {
      setCapturLeads(storedcaptureLeads === "true");
    }

    const storednewsLetter = localStorage.getItem("newsLetter");
    if (storednewsLetter !== null) {
      setNewsLetter(storednewsLetter === "true");
    }

    const storedtwitterBtn = localStorage.getItem("twitterBtn");
    if (storedtwitterBtn !== null) {
      setTwitternButton(storedtwitterBtn === "true");
    }

    const storedfbBtn = localStorage.getItem("fbBtn");
    if (storedfbBtn !== null) {
      setFbButton(storedfbBtn === "true");
    }

    const storedpintrestBtn = localStorage.getItem("pintrestBtn");
    if (storedpintrestBtn !== null) {
      setPintrestButton(storedpintrestBtn === "true");
    }

    const storedlinkedinBtn = localStorage.getItem("linkedinBtn");
    if (storedlinkedinBtn !== null) {
      setLinkedinButton(storedlinkedinBtn === "true");
    }

    const storedvideo = localStorage.getItem("video");
    if (storedvideo !== null) {
      setVideo(storedvideo === "true");
    }

    const storedAuthorDefCheck = localStorage.getItem("authorDefaultCheck");
    if (storedAuthorDefCheck !== null) {
      setUseAsDefault(storedAuthorDefCheck === "true");
    }
  }, []);

  const handleCampaignNameChange = (event: any) => {
    const newName = event.target.value;
    if (newName === planDetails?.product_name) {
      toast.error("Already campaign name exist!");
    } else {
      setCampaignName(newName);
      if (planDetails) {
        setPlanDetails({
          ...planDetails,
          product_name: newName,
        });
      }
      localStorage.setItem("campaignName", newName);
    }
  };

  const handleAuthorNameChange = (event: any) => {
    const newName = event.target.value;
    setName(newName);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        name: newName,
      });
    } else if (userDetails) {
      setUserDetails({
        ...userDetails,
        name: newName,
      });
    }
    localStorage.setItem("Authorname", newName);
  };

  const handleAuthorUrlChange = (event: any) => {
    const newUrl = event.target.value;

    setSocialUrl(newUrl);
    // if (userDetails) {
    //     setUserDetails({
    //         ...userDetails,
    //         social_url: newUrl
    //     })
    // }
    // else
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        social_url: newUrl,
      });
    } else if (userDetails) {
      setUserDetails({
        ...userDetails,
        social_url: newUrl,
      });
    }
    localStorage.setItem("Authorurl", newUrl);
  };

  const handleCopyName = (name: string) => {
    navigator.clipboard.writeText(name).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //toast.success('Copied to Clipboard!');
    });
  };

  const handleCopyscript = (script: string) => {
    navigator.clipboard.writeText(script).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //toast.success('Copied to Clipboard!');
    });
  };

  const handleCopyVal = (value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //oast.success('Copied to Clipboard!');
    });
  };

  const placeholderText = "https://www.youtube.com/watch?v=X7sEkixKk4g&t=1s";

  const code_snippet =
    script; /* `<!- Traffic Monster tag (gtag.js) --> <script async src=https://www.googletagmanage EGRK3ZCMNX"></script> <script> window.dataLayer =
window.dataLayer || []; function gtag() {dataLayer.push(arguments) i) gtag('is' new Date gtag('config', 'G-EGRKзZCMNX');` */

  /* const handleShare = (url: any) => {
        window.open(url, '_blank');
    };

    const shareOnTwitter = () => {
        handleShare(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnPinterest = () => {
        handleShare(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnFacebook = () => {
        handleShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnLinkedin = () => {
        handleShare(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`);
        handleShare(`https://www.linkedin.com/sharing/share-offsite/url=${encodeURIComponent(window.location.href)}`);

    }; */

  useEffect(() => {
    setUserImageUrl(planDetails?.user_image || campDetails?.user_image);
  }, [planDetails]);

  const NormallyValArray = [
    period == "monthly" ? "" : "Normally $14/mo.",
    period == "monthly" ? "" : "Normally $49/mo.",
    period == "monthly" ? "" : "Normally $99/mo.",
    period == "monthly" ? "" : "Normally $149/mo.",
  ];

  const handleChangePayMethodClick = async () => {
    localStorage.setItem("ChangepayMode", "true");
    localStorage.setItem("IdChangingMode", campIdFrEdit);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        apiUrl + `/api/subscription/change_payment_method?email=${user_email}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.data.status === "success") {
        window.open(response.data.portal_url, "_blank");
      }
    } catch (error) {
      console.log("Error changing payment method", error);
    }
  };

  const handleCancelSubscriptionClick = async () => {
    setCancellingLoader(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        apiUrl +
          `/api/subscription/Cancel_Subscription?campaign_id=${campIdFrEdit}`,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        },
      );
      if (response.data.status === "success") {
        setSuccessCancelSubscription(true);
        setConfirmCancelSubscription(false);
        toast.success("Cancelled Subscription!");
      }
    } catch (error) {
      toast.error("Error cancelling subscription");
      console.log("Error cancelling subscription", error);
    } finally {
      setCancellingLoader(false);
    }
  };

  const currentlocationurl = window.location.origin;
  const addtoMyblogscodeSnippet = `<iframe src="${currentlocationurl}/blogs?campaignid=${campIdFrEdit}&header=off" height="600" width="900" title="Iframe Example"></iframe>`;

  const handleCopyCodeSnippet = (value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //toast.success('Copied to Clipboard!');
    });
  };

  const handleuploadvideoChange = async (event: any) => {
    if (urlPrefix === "word" || urlPrefix === "pdf") {
      setLoadingText("Uploading your document...");
    } else {
      setLoadingText("Uploading your video...");
    }
    const file = event.target.files[0];
    if (file) {
      setUploadVideo(file.name);
      console.log("Uploaded video file:", file);
      const formData = new FormData();
      formData.append("media_file", file);

      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      setIsLoadingGetPage(true);
      // setIsUploadLoading(true);
      setLoaderProgress(20);
      try {
        const response = await axios.post(
          `${apiUrl}/api/prompts/upload_media_file`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        console.log(response.data.data);
        if (response.data.result === "success" /* && response.data.data */) {
          setUploadedvideopath(response.data.data);
          setTimeout(() => {
            toast.success("File Uploaded Successfully!");
          }, 1000);
        } else if (response.data.result === "failed") {
          setIsLoadingGetPage(false);
          toast.error(response.data.data);
        }
      } catch (error) {
        console.error("Error uploading video:", error);
        toast.error("Error uploading video");
      } finally {
        // setIsUploadLoading(false);
        setLoaderProgress(100);
        setTimeout(() => {
          setIsLoadingGetPage(false);
          // toast.success('File Uploaded Successfully!');
        }, 1000);
      }
    }
  };

  useEffect(() => {
    setNewsLetter(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setCapturLeads(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setTwitternButton(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setFbButton(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setLinkedinButton(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setVideo(!!planDetails?.embed_youtube_video);
  }, [planDetails]);

  const clearCookies = () => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name] = cookie.split("=");
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
    }
  };

  const handleItemClick = (itemName: any) => {
    localStorage.setItem("activeItem", itemName);
    setActiveItem(
      localStorage.getItem("activeItem")
        ? localStorage.getItem("activeItem")
        : itemName,
    );
    localStorage.removeItem("campaignid");
    localStorage.removeItem("returningtocampaign");
    localStorage.removeItem("sourceurl");
    localStorage.removeItem("campaignName");
    localStorage.removeItem("paymentOption");
    localStorage.removeItem("autoPublish");
    localStorage.removeItem("limitPublish");
    localStorage.removeItem("smUrlpublish");
    localStorage.removeItem("addTags");
    localStorage.removeItem("captureLeads");
    localStorage.removeItem("newsLetter");
    localStorage.removeItem("twitterBtn");
    localStorage.removeItem("fbBtn");
    localStorage.removeItem("pintrestBtn");
    localStorage.removeItem("linkedinBtn");
    localStorage.removeItem("video");
    localStorage.removeItem("twitterurl");
    localStorage.removeItem("fburl");
    localStorage.removeItem("pintresturl");
    localStorage.removeItem("linkedinurl");
    localStorage.removeItem("smUrlpublish");
    localStorage.removeItem("owndomain");
    localStorage.removeItem("ChangepayMode");
    localStorage.removeItem("IdChangingMode");
    localStorage.removeItem("PaymentSubscription");
    localStorage.removeItem("Authorurl");
    localStorage.removeItem("Authorname");
    localStorage.removeItem("authorDefaultCheck");
    localStorage.removeItem("videoTag");
    localStorage.removeItem("podcastUrl");
    localStorage.removeItem("sourcetext");

    if (itemName === "upgrade") {
      /*  const value = {
                 _id: "",
                 product_name: "CodeGenie",
                 product_module: genieSelector.module ? genieSelector.module : "",
                 userid: "",
                 productid: ""
             };
             getProduct(value); */
      localStorage.setItem("fromUpgrade", "true");
      navigate("/pricing", {
        state: {
          campIdFromUpgrade:
            localStorage.getItem("campId") || "" /* selectedCampaign */,
          from_page: "blog_listing",
        },
      });
    } else if (itemName === "logout") {
      clearCookies();
      localStorage.setItem("logged_in", "false");
      //console.log("loggedin:" + localStorage.getItem("logged_in"));
      dispatch(logout());
      var module = localStorage.getItem("module");
      console.log("module111...." + module);

      toast.success("Logout success");
      // localStorage.removeItem("payment");
      localStorage.removeItem("msg");
      localStorage.removeItem("complexity");
      localStorage.removeItem("module");
      localStorage.removeItem("subscription_level");
      localStorage.removeItem("free_plan");
      // localStorage.removeItem("userRole");
      localStorage.removeItem("localStorage_msg");
      localStorage.removeItem("allSet");
      localStorage.removeItem("Blogs Generated");
      localStorage.removeItem("remaining_wish_count");
      localStorage.removeItem("userRole");
      localStorage.removeItem("payment");
      localStorage.removeItem("user_email");
      localStorage.removeItem("logged_in");
      localStorage.removeItem("prevImg");
      localStorage.removeItem("fromUpgrade");
      localStorage.removeItem("blogsCount");
      localStorage.removeItem("Generating Count");
      localStorage.removeItem("finalData");
      localStorage.removeItem("user_pass");
      localStorage.removeItem("fromNewcampaign");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("campId");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("smUrlpublish");
      localStorage.removeItem("addTags");
      localStorage.removeItem("captureLeads");
      localStorage.removeItem("newsLetter");
      localStorage.removeItem("twitterBtn");
      localStorage.removeItem("fbBtn");
      localStorage.removeItem("pintrestBtn");
      localStorage.removeItem("linkedinBtn");
      localStorage.removeItem("video");
      localStorage.removeItem("twitterurl");
      localStorage.removeItem("fburl");
      localStorage.removeItem("pintresturl");
      localStorage.removeItem("linkedinurl");
      localStorage.removeItem("owndomain");
      localStorage.removeItem("ChangepayMode");
      localStorage.removeItem("IdChangingMode");
      localStorage.removeItem("user_name");
      localStorage.removeItem("refreshCount");
      localStorage.removeItem("publishingCampId");
      localStorage.removeItem("Authorurl");
      localStorage.removeItem("Authorname");
      localStorage.removeItem("authorDefaultCheck");
      localStorage.removeItem("appsumo_coupon_code");
      localStorage.removeItem("podcastUrl");
      localStorage.removeItem("AlertMessage");
      localStorage.removeItem("CreatingfromLanding");
      localStorage.removeItem("UrlfromLanding");
      localStorage.removeItem("signedup");
      localStorage.removeItem("uploadedvideo");
      localStorage.removeItem("uploadedVideoName");
      localStorage.removeItem("uploadStatus");
      localStorage.removeItem("editedposthashtags");
      localStorage.removeItem("editedpostblogsummary");
      localStorage.removeItem("editedpostblogtitle");
      localStorage.removeItem("editedposturl");
      localStorage.removeItem("user_email");
      localStorage.removeItem("YoutubeUrlfromLanding");
      localStorage.removeItem("FirstLogin");
      localStorage.removeItem("DirectSignup");
      localStorage.removeItem("FromIndexPage");
      localStorage.removeItem("activeItem");
      localStorage.removeItem("UpdateduserImage");
      localStorage.removeItem("publish_to_code_genie");
      localStorage.removeItem("publish_to_ocesha");
      localStorage.removeItem("competitor_search");
      localStorage.removeItem("FromEditBlog");
      localStorage.removeItem("ErrorAlert");
      localStorage.removeItem("FromSignIn");
      removeCookie("user_email");
      localStorage.clear();

      if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
        navigate("/Anycode_landing");
      else redirectAfterLogout(); //"https://ocesha.ai";
    } else if (itemName == "createcourse") {
      navigate("/codegenie/new-course-2-1");
      return;
    } else if (itemName === "course") {
      navigate("/codegenie/generated-courses");
      return;
    } else {
      navigate("/codegenie/generated-blogs");
    }
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTopicSelect = (topic: any) => {
    setSelectedTopic(topic);
  };

  const handleKeywordSelect = (keyword: any) => {
    setSelectedKeyword(keyword);
  };

  // ─── Sidebar helpers ────────────────────────────────────────────
  const isStudent = userDetails?.role === "student";
  const isLifetime =
    planDetails?.plan_name === "Life Time - STARTER" ||
    planDetails?.plan_name === "Life Time - CREATOR" ||
    planDetails?.plan_name === "Life Time - PROFESSIONAL" ||
    planDetails?.plan_name === "Life Time - ENTERPRISE";

  const renderSidebar = () => (
    <>
      {/* Logo */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2.5, pt: 2.5, pb: 2 }}>
        <Box onClick={() => window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"} sx={{ display: "inline-flex", alignItems: "center", flex: 1, minWidth: 0, cursor: "pointer" }}>
          <Box component="img" src={ocesha_logo} alt="Ocesha" sx={{ height: 32, width: "auto", maxWidth: "100%", objectFit: "contain", display: "block" }} />
        </Box>
        <Tooltip title="Click here for help video">
          <Box component="img" src={youtubeIco1} alt="Help video" onClick={() => { setHelperVideoSrc("/images/Overview.mp4"); setHelperPopup(true); }} sx={{ height: 28, width: "auto", cursor: "pointer", flexShrink: 0 }} />
        </Tooltip>
      </Stack>

      {/* AI Digital Twin card */}
      <Box sx={{ mx: 2, mb: 2, p: 1.5, borderRadius: "12px", background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)", border: "1px solid rgba(255,255,255,0.06)" }}>
        <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.45)", letterSpacing: 1, fontWeight: 600, mb: 1 }}>AI DIGITAL TWIN</Typography>
        <Stack direction="row" spacing={1.2} alignItems="center" mb={1.5}>
          <Box component="img" src={userDetails?.profile_image || RohanImg} alt="Profile" sx={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }} />
          <Box>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{userDetails?.first_name || userDetails?.name || "User"}</Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E" }} />
              <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>AI Twin Online</Typography>
            </Stack>
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" onClick={() => { handleItemClick("digital"); setIsMenuOpen(false); }} sx={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: "8px", px: 1.2, py: 0.6, cursor: "pointer", "&:hover": { background: "rgba(255,255,255,0.07)" } }}>
          <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", flex: 1 }}>Ask My AI Twin</Typography>
          <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.5)" }} />
        </Stack>
      </Box>

      {/* Main nav */}
      <Stack spacing={0.4} sx={{ px: 1.5 }}>
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => { handleItemClick("authority"); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", background: activeItem === "authority" ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent", color: activeItem === "authority" ? "#fff" : "rgba(255,255,255,0.7)", "&:hover": { background: activeItem === "authority" ? undefined : "rgba(255,255,255,0.04)" } }}>
            <InsightsIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "authority" ? 600 : 500 }}>Dashboard</Typography>
          </Stack>
        )}

        <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => { handleItemClick("course"); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", background: activeItem === "course" ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent", color: activeItem === "course" ? "#fff" : "rgba(255,255,255,0.7)", "&:hover": { background: activeItem === "course" ? undefined : "rgba(255,255,255,0.04)" } }}>
          <PlayCircleFilledWhiteOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "course" ? 600 : 500 }}>My Course</Typography>
        </Stack>

        {/* Content Library */}
        {!isStudent && (
          <Box>
            <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => setIsContentOpen(!isContentOpen)} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", color: "rgba(255,255,255,0.7)", "&:hover": { background: "rgba(255,255,255,0.04)" } }}>
              <FolderIcon sx={{ fontSize: 18 }} />
              <Typography sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>Content Library</Typography>
              {isContentOpen ? <KeyboardArrowUpIcon sx={{ fontSize: 16 }} /> : <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
            </Stack>
            {isContentOpen && (
              <Stack spacing={0.3} sx={{ ml: 3, mt: 0.3 }}>
                {[
                  { id: "blogs",      label: "Blogs",       Icon: BlogsIco },
                  { id: "episodes",   label: "Episodes",    Icon: EpisodeIco },
                  { id: "clips",      label: "Clips",       Icon: ClipIco },
                  { id: "images",     label: "Images",      Icon: ImagesIco },
                  { id: "socailpost", label: "Social Post", Icon: null },
                ].map((item) => {
                  const active = activeItem === item.id;
                  const Ico = item.Icon as any;
                  return (
                    <Stack key={item.id} direction="row" spacing={1} alignItems="center" onClick={() => { handleItemClick(item.id); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.2, py: 0.7, borderRadius: "7px", color: active ? "#4BA5EB" : "rgba(255,255,255,0.6)", background: active ? "rgba(75,165,235,0.08)" : "transparent", "&:hover": { background: "rgba(255,255,255,0.03)" } }}>
                      {Ico && <Ico />}
                      <Typography sx={{ fontSize: 12.5 }}>{item.label}</Typography>
                    </Stack>
                  );
                })}
              </Stack>
            )}
          </Box>
        )}

        {/* Create Blog — highlighted as active */}
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center" sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", background: "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)", color: "#fff" }}>
            <AddOutlinedIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: 600 }}>Create Blog</Typography>
          </Stack>
        )}

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => { handleItemClick("digital"); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.5, py: 1, mt: 0.4, borderRadius: "8px", color: activeItem === "digital" ? "#4BA5EB" : "rgba(255,255,255,0.7)", background: activeItem === "digital" ? "rgba(75,165,235,0.08)" : "transparent", "&:hover": { background: "rgba(255,255,255,0.04)" } }}>
            <SmartToyIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>My Digital Twin</Typography>
          </Stack>
        )}
      </Stack>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", my: 2, mx: 2 }} />

      {/* Bottom nav */}
      <Stack spacing={0.4} sx={{ px: 1.5, pb: 2 }}>
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => handleItemClick("upgrade")} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", color: "rgba(255,255,255,0.65)", "&:hover": { background: "rgba(255,255,255,0.04)" } }}>
            <UpgradeIco />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>{isLifetime ? "Features" : "Upgrade"}</Typography>
          </Stack>
        )}
        <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => { handleItemClick("settings"); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", color: activeItem === "settings" ? "#4BA5EB" : "rgba(255,255,255,0.65)", background: activeItem === "settings" ? "rgba(75,165,235,0.08)" : "transparent", "&:hover": { background: "rgba(255,255,255,0.04)" } }}>
          <SettingsIco />
          <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Settings</Typography>
        </Stack>
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => { handleItemClick("analytics"); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", color: activeItem === "analytics" ? "#4BA5EB" : "rgba(255,255,255,0.65)", background: activeItem === "analytics" ? "rgba(75,165,235,0.08)" : "transparent", "&:hover": { background: "rgba(255,255,255,0.04)" } }}>
            <EqualizerIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Analytics</Typography>
          </Stack>
        )}
        <Stack direction="row" spacing={1.2} alignItems="center" onClick={() => { handleItemClick("logout"); setIsMenuOpen(false); }} sx={{ cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px", color: "rgba(255,255,255,0.65)", "&:hover": { background: "rgba(255,255,255,0.04)" } }}>
          <LogoutIco />
          <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Logout</Typography>
        </Stack>
      </Stack>
    </>
  );

  return (
    <>
      <Box sx={{ display: "flex", minHeight: "100vh", width: "100%", background: "#000000", color: "#fff", fontFamily: "'Inter', -apple-system, sans-serif", overflowX: "hidden", boxSizing: "border-box" }}>

        {/* ══ MOBILE HAMBURGER + DRAWER ══ */}
        {isMobile && (
          <>
            <IconButton onClick={handleMenuToggle} sx={{ position: "fixed", top: 10, left: 10, zIndex: 1100, color: "#fff", background: "rgba(0,0,0,0.5)", "&:hover": { background: "rgba(0,0,0,0.7)" } }}>
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            {isMenuOpen && (
              <Box sx={{ position: "fixed", top: 0, left: 0, width: "75%", maxWidth: 300, height: "100vh", zIndex: 1050, background: "linear-gradient(180deg, #0B1220 0%, #06080F 100%)", borderRight: "1px solid rgba(255,255,255,0.06)", overflowY: "auto" }}>
                {renderSidebar()}
              </Box>
            )}
          </>
        )}

        {/* ══ DESKTOP SIDEBAR ══ */}
        {!isMobile && (
          <Box sx={{ width: 260, background: "linear-gradient(180deg, #0B1220 0%, #06080F 100%)", borderRight: "1px solid rgba(255,255,255,0.06)", display: "flex", flexDirection: "column", position: "fixed", top: 0, left: 0, height: "100vh", overflowY: "auto", zIndex: 100 }}>
            {renderSidebar()}
          </Box>
        )}

        {/* ══ MAIN CONTENT ══ */}
        <Box sx={{ flex: 1, ml: !isMobile ? "260px" : 0, minHeight: "100vh", width: !isMobile ? "calc(100% - 260px)" : "100%" }} onClick={() => setIsMenuOpen(false)}>

          {/* TOP HEADER BAR */}
          <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ px: { xs: 2, md: 3 }, py: 1.5, borderBottom: "1px solid rgba(255,255,255,0.06)", background: "rgba(0,0,0,0.4)", position: "sticky", top: 0, zIndex: 10, backdropFilter: "blur(10px)" }}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <IconButton sx={{ position: "relative", color: "rgba(255,255,255,0.7)" }}>
                <NotificationsNoneOutlinedIcon sx={{ fontSize: 22 }} />
                <Box sx={{ position: "absolute", top: 6, right: 6, width: 18, height: 18, borderRadius: "50%", background: "#EF4444", color: "#fff", fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>3</Box>
              </IconButton>
              <Box component="img" src={userDetails?.profile_image || userDetails?.user_image || RohanImg} alt="Profile" onClick={(e: any) => setProfileMenuAnchor(e.currentTarget)} sx={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(255,255,255,0.1)", cursor: "pointer" }} />
              <MuiMenu anchorEl={profileMenuAnchor} open={isProfileMenuOpen} onClose={() => setProfileMenuAnchor(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} PaperProps={{ sx: { mt: 1, background: "#0F1117", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "10px", minWidth: 180, color: "#fff", "& .MuiMenuItem-root": { fontSize: 13, py: 1, px: 1.5, "&:hover": { background: "rgba(255,255,255,0.06)" } }, "& .MuiListItemIcon-root": { minWidth: 32, color: "rgba(255,255,255,0.65)" } } }}>
                <Box sx={{ px: 1.5, py: 1.2, borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{userDetails?.first_name || userDetails?.name || "User"}</Typography>
                  <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: 0.2 }}>{userDetails?.email || user_email}</Typography>
                </Box>
                <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("settings"); }}>
                  <ListItemIcon><SettingsIco /></ListItemIcon>Settings
                </MenuItem>
                <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />
                <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("logout"); }} sx={{ color: "#F87171 !important" }}>
                  <ListItemIcon sx={{ "& svg": { color: "#F87171" } }}><LogoutIco /></ListItemIcon>Logout
                </MenuItem>
              </MuiMenu>
            </Stack>
          </Stack>

          {/* PAGE CONTENT */}
          <Box sx={{ overflowX: "hidden" }}>
      <div style={{ overflowX: "hidden" }}>
        <div className="row">
          {/* <div className="col-10">
                        <Ocesha_header handleItemClick={handleItemClick} />
                    </div> */}

          <div
            className="col-sm-12 col-md-12 col-lg-12" /* style={{ paddingRight: '2%' }} */ /* style={{ margin: '7%' }} */
          >
            <div className="overlay-container">
              <div style={{ width: "98%", marginBottom: "10%" }}>
                {isloadingGetPage && !getPageError && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      zIndex: 9999,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backdropFilter: "blur(5px)",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: "80%",
                        maxWidth: "700px",
                        padding: "20px",
                        backgroundColor: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <Typography style={{ fontSize: "30px" }}>
                        {loadingText}
                        {/* Generating Blogs with AI... */}
                      </Typography>
                      <br></br>
                      {/* <LinearProgress /> */}
                      <ProgressBar
                        completed={loaderProgress}
                        bgColor={loaderProgress >= 90 ? "#10b981" : "#3b82f6"}
                        height="20px"
                        labelColor="#ffffff"
                        labelAlignment="center"
                      />
                      <br></br>
                      <Typography style={{ fontSize: "20px" }}>
                        This may take a few seconds{/* a couple minutes */}...
                      </Typography>
                    </div>
                  </div>
                )}

                {planDetails?.payment_status === "pending" ? (
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Box
                        sx={{
                          background: "#090619",
                          borderRadius: "5px",
                          padding: isMobile ? "6%" : "2%",
                          width: isMobile ? "100%" : "50%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: "bolder",
                            color: "#fff",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginBottom: "2%",
                            }}
                          >
                            <InfoIcon
                              style={{ color: "Orange", fontSize: "30px" }}
                            />
                          </span>
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {
                              "Note: Subscription is PENDING, please complete the payment."
                            }
                          </span>
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                <Grid container spacing={2} sx={{ paddingLeft: "1%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      sx={{
                        fontSize: "32px",
                        fontWeight: "bolder",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {/* {(FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true') ? 'Edit Campaign' : 'New Campaign'} */}
                      Create Blogs
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ paddingLeft: "1%" }}>
                  <Grid item xs={12} sm={12}></Grid>
                </Grid>

                {/* <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded1
                          ? isMobile
                            ? "626px"
                            : "500px"
                          : isMobile
                            ? "264px"
                            : "155px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          // height: '100px',
                          height: isMobile ? "" : "155px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded1 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                          display: isMobile ? "block" : "-webkit-inline-flex",
                        }}
                        onClick={handleExpandClick1}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          {
                            "Add Your Website URL, Youtube URL, Upload Text, Video file, or Audio file" 
                          }
                          <span style={{ color: "red" }}>*</span>
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            We will create your blogs based on your uploaded
                            content.
                          </Typography>
                        </Box>

                        <Box>
                          {expanded1 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                      </Button>
                      <Collapse in={expanded1} style={{ marginTop: "2%" }}>
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              sx={{
                                color: "#d1d5db",
                                display:
                                  urlPrefix === "text" ||
                                  planDetails?.source === "text"
                                    ? ""
                                    : "flex",
                                alignItems:
                                  urlPrefix === "text" ||
                                  planDetails?.source === "text"
                                    ? ""
                                    : "center",
                              }}
                            >
                              <Paper
                                elevation={3}
                                sx={{
                                  padding: 1,
                                  backgroundColor: "#21262d",
                                  borderRadius: "4px",
                                  width: "100%",
                                }}
                              >
                                <Select
                                  value={
                                    campDetails?.source === "upload"
                                      ? "upload"
                                      : campDetails?.source === "youtube"
                                        ? "youtubeid"
                                        : campDetails?.source === "url"
                                          ? "https://"
                                          : campDetails?.source === "text"
                                            ? "text"
                                            : urlPrefix
                                  }
                                  onChange={(event) => {
                                    if (
                                      campDetails?.source !== "upload" &&
                                      campDetails?.source !== "youtube" &&
                                      campDetails?.source !== "url" &&
                                      campDetails?.source !== "text"
                                    ) {
                                      const selectedValue = event.target.value;
                                      setUrlPrefix(event.target.value);

                                      switch (selectedValue) {
                                        case "https://":
                                          setSourceUrl(""); // Clear Website URL
                                          break;
                                        case "youtubeid":
                                          setSourceYoutubeUrl(""); // Clear YouTube URL
                                          break;
                                        case "text":
                                          setUserBusinessText(""); // Clear Text area
                                          break;
                                        case "upload":
                                          // Clear uploaded file or handle accordingly
                                          break;
                                        default:
                                          break;
                                      }
                                    }
                                  }}
                                  IconComponent={KeyboardArrowDownIcon}
                                  sx={{
                                    width: "100%",
                                    height: "35px",
                                    ".MuiInputBase-root": {
                                      height: "100%",
                                    },
                                    backgroundColor: "#21262d",
                                    color: "#e5e7eb",
                                    "& .MuiSelect-icon": {
                                      color: "#9ca3af",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "transparent",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "transparent",
                                      },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "transparent",
                                      },
                                  }}
                                >
                                  <MenuItem value="https://">
                                    Website URL
                                  </MenuItem>
                                  <MenuItem value="text">Text</MenuItem>
                                  <MenuItem value="youtubeid">
                                    Youtube Url
                                  </MenuItem>
                                  <MenuItem value="upload">
                                    Upload Video/Audio File
                                  </MenuItem>
                                  <MenuItem value="word">
                                    Upload Word File
                                  </MenuItem>
                                  <MenuItem value="pdf">
                                    Upload Pdf File
                                  </MenuItem>
                                </Select>
                              </Paper>
                            </Grid>

                            <Grid item xs={12} sm={10}>
                              <Paper
                                elevation={3}
                                sx={{
                                  padding: 1,
                                  backgroundColor: "#21262d",
                                  borderRadius: "4px",
                                  width: "100%",
                                }}
                              >
                                {urlPrefix === "text" ||
                                campDetails?.source === "text" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <TextareaAutosize
                                      style={{
                                        width: "100%",
                                        height: "200px",
                                        borderColor: "#30363d",
                                        borderRadius: "5px",
                                        backgroundColor: "#0d1117",
                                        color: "#e5e7eb",
                                        overflow: "auto",
                                      }}
                                      value={
                                        campDetails
                                          ? campDetails?.product_desc
                                          : userBusinessText
                                      }
                                      onChange={handleTextChange}
                                      placeholder="Enter your business text"
                                    ></TextareaAutosize>
                                  </div>
                                ) : urlPrefix === "https://" ||
                                  campDetails?.source === "url" ? (
                                  <TextField
                                    placeholder="Enter your website url"
                                    sx={{
                                      backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                      width: "100%",
                                      height: "35px",
                                      ".MuiInputBase-root": {
                                        height: "100%",
                                      },
                                      pointerEvents: FromEdit
                                        ? "none"
                                        : "block",
                                    }}
                                    InputProps={{
                                      readOnly: FromEdit,
                                    }}
                                    value={
                                      campDetails ? campDetails?.url : sourceUrl
                                    }
                                    onChange={handleSourceUrlChange}
                                    id="sourceurl"
                                  ></TextField>
                                ) : urlPrefix === "youtubeid" ||
                                  campDetails?.source === "youtube" ? (
                                  <TextField
                                    placeholder="Enter youtube url"
                                    sx={{
                                      backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                      width: "100%",
                                      height: "35px",
                                      ".MuiInputBase-root": {
                                        height: "100%",
                                      },
                                      pointerEvents: FromEdit
                                        ? "none"
                                        : "block",
                                    }}
                                    InputProps={{
                                      readOnly: FromEdit,
                                    }}
                                    value={
                                      campDetails
                                        ? campDetails?.youtube
                                        : sourceYoutubeUrl
                                    }
                                    onChange={handleSourceYoutubeUrlChange}
                                    id="sourceyoutubeurl"
                                  ></TextField>
                                ) : urlPrefix === "upload" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <input
                                      type="file"
                                      accept="video/*,audio/*"
                                      style={{
                                        width: "100%",
                                        height: "35px",
                                        borderColor: "#30363d",
                                        borderRadius: "5px",
                                        backgroundColor: "#0d1117",
                                        color: "#e5e7eb",
                                        padding: "4px 10px",
                                        lineHeight: "23px",
                                      }}
                                      onChange={handleuploadvideoChange}
                                    />
                                    {isUploadLoading ? (
                                      <CircularProgress
                                        size={35}
                                        style={{ marginRight: "1%" }}
                                      />
                                    ) : null}
                                  </div>
                                ) : urlPrefix === "word" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <input
                                      type="file"
                                      accept=".doc,.docx,"
                                      style={{
                                        width: "100%",
                                        height: "35px",
                                        borderColor: "#30363d",
                                        borderRadius: "5px",
                                        backgroundColor: "#0d1117",
                                        color: "#e5e7eb",
                                        padding: "4px 10px",
                                        lineHeight: "23px",
                                      }}
                                      onChange={handleuploadvideoChange}
                                    />
                                    {isUploadLoading ? (
                                      <CircularProgress
                                        size={35}
                                        style={{ marginRight: "1%" }}
                                      />
                                    ) : null}
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <input
                                      type="file"
                                      accept=".pdf"
                                      style={{
                                        width: "100%",
                                        height: "35px",
                                        borderColor: "#30363d",
                                        borderRadius: "5px",
                                        backgroundColor: "#0d1117",
                                        color: "#e5e7eb",
                                        padding: "4px 10px",
                                        lineHeight: "23px",
                                      }}
                                      onChange={handleuploadvideoChange}
                                    />
                                    {isUploadLoading ? (
                                      <CircularProgress
                                        size={35}
                                        style={{ marginRight: "1%" }}
                                      />
                                    ) : null}
                                  </div>
                                )}
                              </Paper>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            spacing={2}
                            sx={{ marginTop: "1px" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={2} 
                            >
                              <Paper
                                elevation={3}
                                sx={{
                                  padding: 1,
                                  backgroundColor: "#21262d",
                                  borderRadius: "4px",
                                  width: "100%",
                                  height: "100%",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <Typography sx={{ color: "#000" }}>
                                  Blogs count
                                </Typography>
                              </Paper>
                            </Grid>

                            <Grid item xs={12} sm={10}>
                              <Paper
                                elevation={3}
                                sx={{
                                  padding: 1,
                                  backgroundColor: "#21262d",
                                  borderRadius: "4px",
                                  width: isMobile ? "20%" : "12%",
                                  marginTop: "1px",
                                }}
                              >
                                <TextField
                                  sx={{
                                    backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                    width: "100%",
                                    height: "35px",
                                    ".MuiInputBase-root": {
                                      height: "100%",
                                    },
                                    pointerEvents: FromEdit ? "none" : "block",
                                  }}
                                  value={1}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Paper>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            spacing={2}
                            sx={{ marginTop: "1px", display: "none" }}
                          >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails?.competetor_search ??
                                        competitorSearch
                                      }
                                      onChange={handleCompetitorSearchChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                    color: "#d1d5db",
                                  }}
                                >
                                  Include Competitor Research
                                </span>
                              </span>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid> */}

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded10
                          ? "500px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded10 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick10}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Author
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            Use this information as the Author of the blogs
                          </Typography>
                        </Box>
                        <Box>
                          {expanded10 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                      </Button>
                      <Collapse in={expanded10} style={{ marginTop: "2%" }}>
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <div>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                  }}
                                >
                                  Name
                                </Typography>
                                <TextField
                                  placeholder="Enter your name"
                                  id="uname"
                                  sx={{
                                    backgroundColor: "#161b22",
                                    width: "100%",
                                    height: "40px",
                                    "& .MuiInputBase-input": {
                                      color: "#ffffff",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                      color: "#9ca3af",
                                      opacity: 1,
                                    },
                                    ".MuiInputBase-root": {
                                      height: "100%",
                                      border: "none",
                                      borderRadius: "5px",
                                      "&:hover fieldset": {
                                        borderColor: "#CBCBCB",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "#CBCBCB",
                                        boxShadow: "none",
                                      },
                                    },
                                    border: "1px solid #CBCBCB",
                                    borderRadius: "5px",
                                    "&:hover": {
                                      border: "none",
                                    },
                                    // marginLeft: '10px'
                                  }}
                                  value={
                                    campDetails?.name
                                      ? campDetails?.name
                                      : name /*planDetails ? planDetails?.name : name */
                                  }
                                  onChange={
                                    handleAuthorNameChange /* (e) => setName(e.target.value) */
                                  }
                                />
                              </div>
                              <div style={{ marginTop: "1%" }}>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                  }}
                                >
                                  Upload your profile image
                                </Typography>
                                <input
                                  type="file"
                                  accept="image/*"
                                  style={{ width: "100%" }}
                                  onChange={handleImageChange}
                                />
                                {(userImageUrl || userDetails?.user_image) && (
                                  <img
                                    src={
                                      userImageUrl || userDetails?.user_image
                                    }
                                    /* src={`${userImageUrl}?${Date.now()}`} */ alt="Uploaded"
                                    style={{
                                      maxWidth: "50px",
                                      marginTop: "1rem",
                                      height: "50px",
                                    }}
                                  />
                                )}
                              </div>
                              <div style={{ marginTop: "1%" }}>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                  }}
                                >
                                  URL
                                </Typography>
                                <TextField
                                  placeholder="E.g. https://www.linkedin.com/in/profile_name"
                                  id="authurl"
                                  sx={{
                                    backgroundColor: "#161b22",
                                    width: "100%",
                                    height: "40px",
                                    "& .MuiInputBase-input": {
                                      color: "#ffffff",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                      color: "#9ca3af",
                                      opacity: 1,
                                    },
                                    ".MuiInputBase-root": {
                                      height: "100%",
                                      border: "none",
                                      borderRadius: "5px",
                                      "&:hover fieldset": {
                                        borderColor: "#CBCBCB",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "#CBCBCB",
                                        boxShadow: "none",
                                      },
                                    },
                                    border: "1px solid #CBCBCB",
                                    borderRadius: "5px",
                                    "&:hover": {
                                      border: "none",
                                    },
                                    // marginLeft: '10px'
                                  }}
                                  value={
                                    campDetails?.social_url
                                      ? campDetails?.social_url
                                      : socialUrl
                                  }
                                  onChange={
                                    handleAuthorUrlChange /* (e) => setSocialUrl(e.target.value) */
                                  }
                                />
                              </div>
                              <div style={{ marginTop: "1%" }}>
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        id="usedefault"
                                        checked={
                                          campDetails
                                            ? campDetails?.use_as_default
                                            : userDetails
                                              ? userDetails?.blog_default
                                              : useAsDefault
                                        }
                                        onChange={
                                          handleAuthorUseDefaultChange /* (e) => setUseAsDefault(e.target.checked) */
                                        }
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                      color: "#ffffff",
                                    }}
                                  >
                                    Use this information on my blogs.
                                  </span>
                                </span>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded14
                          ? "500px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded14 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick14}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Include Table of Content
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            A Table of Contents improves readability,
                            navigation, SEO, and user experience by allowing
                            readers to quickly find and access specific sections
                            of a blog.
                          </Typography>
                        </Box>
                        <Box>
                          {expanded14 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                      </Button>
                      <Collapse in={expanded14} style={{ marginTop: "2%" }}>
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails
                                          ? campDetails?.toc
                                          : toc
                                            ? toc
                                            : false /* localStorage.getItem('addTags') */
                                      }
                                      onChange={handletocChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                  }}
                                >{`Yes, please add a TOC to my blogs`}</span>
                              </span>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded15
                          ? "500px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded15 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick15}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Include External Links
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            External links enhance a blog's credibility, SEO,
                            and user experience by providing additional
                            resources, supporting claims and improving search
                            engine rankings.
                          </Typography>
                        </Box>
                        <Box>
                          {expanded15 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                      </Button>
                      <Collapse in={expanded15} style={{ marginTop: "2%" }}>
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails
                                          ? campDetails?.external_links
                                          : externalLinks
                                            ? externalLinks
                                            : false /* localStorage.getItem('addTags') */
                                      }
                                      onChange={handleexternalLinksChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                  }}
                                >{`Yes, please add external links to my blogs`}</span>
                              </span>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded5
                          ? "500px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded5 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick5}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Add Tags
                          {/* <span style={{ color: 'red' }}>*</span> */}
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            This will add keyword tags to each page for better
                            SEO search results
                          </Typography>
                        </Box>
                        <Box>
                          {expanded5 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                      </Button>
                      <Collapse in={expanded5} style={{ marginTop: "2%" }}>
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails
                                          ? campDetails?.addtags
                                          : addtags
                                            ? addtags
                                            : false /* localStorage.getItem('addTags') */
                                      }
                                      onChange={handleaddtagsChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                  }}
                                >{`Yes, please add tags to my pages (example below)`}</span>
                              </span>
                              <div style={{ marginLeft: "46px" }}>
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "lighter",
                                    display: "block",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#D92D20",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Tags:
                                  </span>{" "}
                                  2024 giftings, beach, blockchain, email,
                                  google, Publish, Update, Author & Tags,
                                  dropdown
                                  <br />
                                  new tag, HubSpot account, website etc.
                                </span>
                              </div>
                              {/* <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={planDetails ? planDetails?.video : (video ? video : localStorage.getItem('video'))}
                                                            onChange={handlevideoChange}
                                                            style={{ color: '#344054', borderColor: '#344054' }}

                                                        />
                                                    }
                                                    label=""
                                                />
                                                <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>{`Yes, add a video to each of my blog page`}</span>
                                            </span> */}
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                {/* {planDetails?.instant_indexing_with_google ?
                                    <Grid container spacing={2} sx={{ marginTop: '3%', paddingLeft: '1%' }}>
                                        <Grid item xs={12} sm={12}>
                                            <Box
                                                sx={{
                                                    width: '100%',
                                                    background: '#fff',
                                                    borderRadius: '8px',
                                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                    overflow: 'hidden',
                                                    transition: 'max-height 0.3s ease-in-out',
                                                    maxHeight: expanded2 ? '500px' : (isMobile ? '150px' : '100px')
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        width: '100%',
                                                        height: isMobile ? '150px' : '100px',
                                                        fontSize: '20px',
                                                        fontWeight: 'bold',
                                                        borderBottom: expanded2 ? '1px solid #ddd' : 'none',
                                                        background: '#D0D5DD',
                                                        justifyContent: 'space-between',
                                                        color: '#344054',
                                                        '&:hover': {
                                                            background: '#D0D5DD',
                                                        }
                                                    }}
                                                    onClick={handleExpandClick2}
                                                >
                                                    <Box sx={{ textAlign: 'left' }}>
                                                        Auto Publish Blogs
                                                        <Typography component="span" sx={{ display: 'block', fontSize: '16px', fontWeight: 'normal' }}>
                                                            You can auto publish your blogs to Google for indexing
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        {expanded2 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    </Box>
                                                </Button>
                                                <Collapse in={expanded2} style={{ marginTop: '2%' }}>
                                                    <Box
                                                        sx={{
                                                            padding: '16px',
                                                            background: '#f9f9f9',
                                                            borderRadius: '0 0 8px 8px',
                                                            backgroundColor: '#fff',
                                                        }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} sx={{
                                                                color: '#344054',
                                                            }}>
                                                                <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                // checked={(planDetails ? planDetails?.autopublish : (autoPublish ? autoPublish : false))}
                                                                                checked={planDetails?.autopublish ?? autoPublish}
                                                                                onChange={handleAutoPublishChange}
                                                                                style={{ color: '#344054', borderColor: '#344054' }}

                                                                            />
                                                                        }
                                                                        label=""
                                                                    />
                                                                    <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>Automatically publish newly created blogs.</span>
                                                                </span>
                                                                <div style={{ marginLeft: '46px' }}>
                                                                    <span style={{ fontSize: '16px', fontWeight: 'lighter', display: 'block' }}>This option automatically publish and index your blog when they are created. Uncheck box to manually publish your blog page.</span>
                                                                </div>
                                                            </Grid>

                                                            {userDetails?.partner === 1 ?
                                                                <Grid item xs={12} sm={12} sx={{
                                                                    color: '#344054',
                                                                }}>
                                                                    <span style={{ fontSize: '18px', display: 'block', fontWeight: 'bold' }}>Publish To</span>
                                                                    <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={campDetails?.publish_to_ocesha ?? publishToOcesha}
                                                                                    onChange={handlePublishToOceshaChange}
                                                                                    style={{ color: '#344054', borderColor: '#344054' }}

                                                                                />
                                                                            }
                                                                            label=""
                                                                        />
                                                                        <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>Ocesha Server</span>
                                                                    </span>
                                                                    <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={campDetails?.publish_to_code_genie ?? publishToCodegenie}
                                                                                    onChange={handlePublishToCodegenieChange}
                                                                                    style={{ color: '#344054', borderColor: '#344054' }}

                                                                                />
                                                                            }
                                                                            label=""
                                                                        />
                                                                        <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>Code Genie Server</span>
                                                                    </span>
                                                                </Grid> : ''}
                                                        </Grid>
                                                    </Box>
                                                </Collapse>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    : ""
                                } */}

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded11
                          ? "500px"
                          : isMobile
                            ? "265px"
                            : "150px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "265px" : "150px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded11 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick11}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Add Video
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            This will automatically add a video to your page.
                            This will create engagement and better ranking of
                            your pages<br></br>
                            Note: We currently support only YouTube videos. You
                            can add 1 YouTube video url below. The video will be
                            added to all new blogs created. You can change the
                            video for each blog from the My Blogs page by
                            clicking Edit Blog.
                          </Typography>
                        </Box>
                        {/* {(subscriptionTH === true && mode === 'Free Trial') ?
                                    <Box>
                                        <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Pending Activation</Button>
                                    </Box> :
                                    (subscriptionFromCampList || planDetails?.subscription_level === 'level_0' || planDetails?.subscription_level === 'level_0y' || planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2' || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5' || planDetails?.mode == "Free Trial" || selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1' || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5'
                                        || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
                                        || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5'
                                    ) ?
                                        <Box>
                                            <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Campaign Hacker Premium Feature</Button>
                                        </Box>
                                        : */}
                        <Box>
                          {expanded11 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                        {/* } */}
                      </Button>
                      <Collapse
                        in={expanded11 /* && !subscriptionFromCampList */}
                        style={{ marginTop: "2%" }}
                      >
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db",
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails
                                          ? campDetails?.video
                                          : video
                                            ? video
                                            : false
                                      }
                                      onChange={handlevideoChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                  }}
                                >{`Yes, add a video to each of my blog page`}</span>
                              </span>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db",
                              }}
                            >
                              <TextareaAutosize
                                style={{
                                  borderRadius: "7px",
                                  border: "1px solid #CBCBCB",
                                  height: "150px",
                                  width: "100%",
                                  fontSize: "14px",
                                  fontWeight: "lighter",
                                }}
                                placeholder={placeholderText}
                                value={
                                  campDetails ? campDetails?.videotag : videoTag
                                }
                                onChange={handlevideotag}
                              ></TextareaAutosize>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded9
                          ? "none"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded9 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick9}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Capture Leads
                          {/* <span style={{ color: 'red' }}>*</span> */}
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            This will add a leads capture form on your blog
                            pages.
                          </Typography>
                        </Box>
                        {/* {(subscriptionTH === true && mode === 'Free Trial') ?
                                    <Box>
                                        <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Pending Activation</Button>
                                    </Box> :
                                    (subscriptionFromCampList || planDetails?.subscription_level === 'level_0' || planDetails?.subscription_level === 'level_0y' || planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2' || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5' || planDetails?.mode == "Free Trial" || selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1' || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5'
                                        || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
                                        || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5'
                                    ) ?
                                        <Box>
                                            <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Campaign Hacker Premium Feature</Button>
                                        </Box>
                                        : */}
                        <Box>
                          {expanded9 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                        {/* } */}
                      </Button>
                      <Collapse
                        in={
                          expanded9 /* && !subscriptionFromCampList */ /* (planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2' || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5') */
                        }
                        style={{ marginTop: "2%" }}
                      >
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails
                                          ? campDetails?.capturleads
                                          : capturleads
                                            ? capturleads
                                            : false /* localStorage.getItem('captureLeads') */
                                      }
                                      onChange={handlecapturleadsChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Yes, please add the below leads capture form
                                  to my blogs.
                                </span>
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent:
                                    "center" /* , alignItems: 'center' */,
                                  height: isMobile ? "70vh" : "70vh",
                                }}
                              >
                                <Box
                                  sx={{
                                    border: "1px solid #CBCBCB",
                                    padding: "3%",
                                    borderRadius: "6px",
                                    width: isMobile ? "95%" : "50%",
                                    height: isMobile ? "450px" : "500px",
                                    marginTop: "2%",
                                  }}
                                >
                                  <div>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bolder",
                                        color: "#ffffff",
                                      }}
                                    >
                                      Contact Us
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "lighter",
                                      }}
                                    >
                                      Reach out to us and let us know how we can
                                      help you.
                                    </Typography>
                                  </div>
                                  <div style={{ marginTop: "7%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#ffffff",
                                      }}
                                    >
                                      Name
                                    </Typography>
                                    <TextField
                                      placeholder="Enter your name"
                                      sx={{
                                        backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                        width: "100%",
                                        height: "40px",
                                        ".MuiInputBase-root": {
                                          height: "100%",
                                          border: "none",
                                          borderRadius: "5px",
                                          "&:hover fieldset": {
                                            borderColor: "#CBCBCB",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#CBCBCB",
                                            boxShadow: "none",
                                          },
                                        },
                                        border: "1px solid #CBCBCB",
                                        borderRadius: "5px",
                                        "&:hover": {
                                          border: "none",
                                        },
                                        // marginLeft: '10px'
                                      }}
                                      inputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginTop: "2%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#ffffff",
                                      }}
                                    >
                                      Email
                                    </Typography>
                                    <TextField
                                      placeholder="Enter your email"
                                      sx={{
                                        backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                        width: "100%",
                                        height: "40px",
                                        ".MuiInputBase-root": {
                                          height: "100%",
                                          border: "none",
                                          borderRadius: "5px",
                                          "&:hover fieldset": {
                                            borderColor: "#CBCBCB",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#CBCBCB",
                                            boxShadow: "none",
                                          },
                                        },
                                        border: "1px solid #CBCBCB",
                                        borderRadius: "5px",
                                        "&:hover": {
                                          border: "none",
                                        },
                                        // marginLeft: '10px'
                                      }}
                                      inputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginTop: "2%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#ffffff",
                                      }}
                                    >
                                      Phone
                                    </Typography>
                                    <TextField
                                      placeholder="Enter your phone number"
                                      sx={{
                                        backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                        width: "100%",
                                        height: "40px",
                                        ".MuiInputBase-root": {
                                          height: "100%",
                                          border: "none",
                                          borderRadius: "5px",
                                          "&:hover fieldset": {
                                            borderColor: "#CBCBCB",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#CBCBCB",
                                            boxShadow: "none",
                                          },
                                        },
                                        border: "1px solid #CBCBCB",
                                        borderRadius: "5px",
                                        "&:hover": {
                                          border: "none",
                                        },
                                        // marginLeft: '10px'
                                      }}
                                      inputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginTop: "2%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#ffffff",
                                      }}
                                    >
                                      How can we help?
                                    </Typography>
                                    <TextField
                                      placeholder="Let us know how we can help you"
                                      sx={{
                                        backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                        width: "100%",
                                        height: "40px",
                                        ".MuiInputBase-root": {
                                          height: "100%",
                                          border: "none",
                                          borderRadius: "5px",
                                          "&:hover fieldset": {
                                            borderColor: "#CBCBCB",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#CBCBCB",
                                            boxShadow: "none",
                                          },
                                        },
                                        border: "1px solid #CBCBCB",
                                        borderRadius: "5px",
                                        "&:hover": {
                                          border: "none",
                                        },
                                        // marginLeft: '10px'
                                      }}
                                      inputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginTop: "5%" }}>
                                    {/* <Button variant="contained" sx={{width: '100%'}}>Subscribe</Button> */}
                                    <Button
                                      variant="contained"
                                      sx={{
                                        width: "100%",
                                        background: "#161b22",
                                        color: "#667085",
                                        "&:hover": {
                                          background: "#161b22",
                                        },
                                      }}
                                    >
                                      Contact Us
                                    </Button>
                                  </div>
                                </Box>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              >
                                {/* <TwitterIcon /> */}&nbsp;
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                {/* <Grid container spacing={2} sx={{ marginTop: '3%' }}>
                    <Grid item xs={12} sm={12}>
                        <Box
                            sx={{
                                width: '100%',
                                background: '#fff',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                overflow: 'hidden',
                                transition: 'max-height 0.3s ease-in-out',
                                maxHeight: expanded6 ? '500px' : (isMobile ? '150px' : '100px')
                            }}
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    width: '100%',
                                    height: isMobile ? '150px' : '100px',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    borderBottom: expanded6 ? '1px solid #ddd' : 'none',
                                    background: '#D0D5DD',
                                    justifyContent: 'space-between',
                                    color: '#344054',
                                    '&:hover': {
                                        background: '#D0D5DD',
                                    }
                                }}
                                onClick={handleExpandClick6}
                            >
                                <Box sx={{ textAlign: 'left' }}>
                                    My Social Media Links
                                    <Typography component="span" sx={{ display: 'block', fontSize: '16px', fontWeight: 'normal' }}>
                                        This will drive traffic from your blog to your social media page with clicked on.
                                    </Typography>
                                </Box>
                                <Box>
                                    {expanded6 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </Box>
                            </Button>
                            <Collapse in={expanded6} style={{ marginTop: '2%' }}>
                                <Box
                                    sx={{
                                        padding: '16px',
                                        background: '#f9f9f9',
                                        borderRadius: '0 0 8px 8px',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} sx={{
                                            color: '#344054'
                                        }}>
                                            <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={!FromEdit ? (campDetails ? campDetails?.linkedinurl || campDetails?.fburl || campDetails?.twitterurl || campDetails?.pintresturl : (socialMediaUrlPublish != null ? socialMediaUrlPublish : localStorage.getItem('smUrlpublish'))) : socialMediaUrlPublish != null ? socialMediaUrlPublish : campDetails ? campDetails?.linkedinurl || campDetails?.fburl || campDetails?.twitterurl || campDetails?.pintresturl : 0}
                                                            onChange={handlesocialMediaUrlPublishChange}
                                                            style={{ color: '#344054', borderColor: '#344054' }}

                                                        />
                                                    }
                                                    label=""
                                                />
                                                <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>Yes, please add the below social media links to my blog pages.</span>
                                            </span><br></br><br></br>
                                            <div style={{ marginLeft: '46px', display: 'flex' }}>
                                                <TwitterIcon /><TextField
                                                    placeholder="Paste your tweeter URL"
                                                    sx={{
                                                        backgroundColor: '#fff',
                                                        width: '50%',
                                                        height: '40px',
                                                        '.MuiInputBase-root': {
                                                            height: '100%',
                                                            '.MuiOutlinedInput-root': {
                                                                height: '100%',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                '&:hover fieldset': {
                                                                    borderColor: '#CBCBCB',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: '#CBCBCB',
                                                                    boxShadow: 'none',
                                                                },
                                                            },
                                                        },
                                                        border: '1px solid #CBCBCB',
                                                        borderRadius: '5px',
                                                        marginLeft: '10px',
                                                        '&:hover': {
                                                            border: 'none'
                                                        }
                                                    }}
                                                    value={campDetails ? campDetails?.twitterurl : twitterUrl}
                                                    onChange={handletwitterUrlChange}></TextField>
                                            </div>

                                            <div style={{ marginLeft: '46px', display: 'flex', marginTop: '2%' }}>
                                                <PinterestIcon /><TextField
                                                    placeholder="Paste your pinterest URL"
                                                    sx={{
                                                        backgroundColor: '#fff',
                                                        width: '50%',
                                                        height: '40px',
                                                        '.MuiInputBase-root': {
                                                            height: '100%',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            '&:hover fieldset': {
                                                                borderColor: '#CBCBCB',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: '#CBCBCB',
                                                                boxShadow: 'none',
                                                            },
                                                        },
                                                        border: '1px solid #CBCBCB',
                                                        borderRadius: '5px',
                                                        marginLeft: '10px',
                                                        '&:hover': {
                                                            border: 'none'
                                                        }
                                                    }}
                                                    value={campDetails ? campDetails?.pintresturl : pintrestUrl}
                                                    onChange={handlepintrestUrlChange}></TextField>
                                            </div>

                                            <div style={{ marginLeft: '46px', display: 'flex', marginTop: '2%' }}>
                                                <FacebookIcon /><TextField
                                                    placeholder="Paste your facebook URL"
                                                    sx={{
                                                        backgroundColor: '#fff',
                                                        width: '50%',
                                                        height: '40px',
                                                        '.MuiInputBase-root': {
                                                            height: '100%',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            '&:hover fieldset': {
                                                                borderColor: '#CBCBCB',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: '#CBCBCB',
                                                                boxShadow: 'none',
                                                            },
                                                        },
                                                        border: '1px solid #CBCBCB',
                                                        borderRadius: '5px',
                                                        marginLeft: '10px',
                                                        '&:hover': {
                                                            border: 'none'
                                                        }
                                                    }}
                                                    value={campDetails ? campDetails?.fburl : fbUrl}
                                                    onChange={handlefbUrlChange}></TextField>
                                            </div>

                                            <div style={{ marginLeft: '46px', display: 'flex', marginTop: '2%' }}>
                                                <LinkedinIcon /><TextField
                                                    placeholder="Paste your linkedIn URL"
                                                    sx={{
                                                        backgroundColor: '#fff',
                                                        width: '50%',
                                                        height: '40px',
                                                        '.MuiInputBase-root': {
                                                            height: '100%',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            '&:hover fieldset': {
                                                                borderColor: '#CBCBCB',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: '#CBCBCB',
                                                                boxShadow: 'none',
                                                            },
                                                        },
                                                        border: '1px solid #CBCBCB',
                                                        borderRadius: '5px',
                                                        marginLeft: '10px',
                                                        '&:hover': {
                                                            border: 'none'
                                                        }
                                                    }}
                                                    value={campDetails ? campDetails?.linkedinurl : linkedinUrl}
                                                    onChange={handlelinkedinUrlChange}></TextField>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Collapse>
                        </Box>
                    </Grid>
                </Grid> */}

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded7
                          ? "700px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded7 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick7}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Newsletter
                          {/* <span style={{ color: 'red' }}>*</span> */}
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            Your audience will be able to sign up for your
                            newsletter, allowing you to capture leads and follow
                            up.
                          </Typography>
                        </Box>
                        {/*  {(subscriptionTH === true && mode === 'Free Trial') ?
                                    <Box>
                                        <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Pending Activation</Button>
                                    </Box> :
                                    (subscriptionFromCampList || planDetails?.subscription_level === 'level_0' || planDetails?.subscription_level === 'level_0y'
                                        || planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2'
                                        || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5' || planDetails?.mode == "Free Trial"
                                        || selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
                                        || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5'
                                        || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
                                        || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') ?
                                        <Box>
                                            <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Campaign Hacker Premium Feature</Button>
                                        </Box>
                                        : */}
                        <Box>
                          {expanded7 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                        {/* } */}
                      </Button>
                      <Collapse
                        in={
                          expanded7 /* && !subscriptionFromCampList */ /* (planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2' || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5') */
                        }
                        style={{ marginTop: "2%" }}
                      >
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        campDetails
                                          ? campDetails?.newsletter
                                          : newsletter
                                      }
                                      onChange={handlenewsletterChange}
                                      style={{
                                        color: "#d1d5db",
                                        borderColor: "#344054",
                                      }}
                                    />
                                  }
                                  label=""
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    display: "block",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Yes, please add the newsletter form to my blog
                                  pages.
                                </span>
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent:
                                    "center" /* , alignItems: 'center' */,
                                  height: isMobile ? "40vh" : "50vh",
                                }}
                              >
                                <Box
                                  sx={{
                                    border: "1px solid #CBCBCB",
                                    padding: "3%",
                                    borderRadius: "6px",
                                    width: isMobile ? "95%" : "50%",
                                    height: isMobile ? "250px" : "300px",
                                    marginTop: "2%",
                                  }}
                                >
                                  <div>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bolder",
                                        color: "#ffffff",
                                      }}
                                    >
                                      Newsletter
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "lighter",
                                      }}
                                    >
                                      Signup for exclusive offers, original
                                      stories, events and more.
                                    </Typography>
                                  </div>
                                  <div style={{ marginTop: "7%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#ffffff",
                                      }}
                                    >
                                      Email
                                    </Typography>
                                    <TextField
                                      className=""
                                      placeholder="Enter your email"
                                      sx={{
                                        backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                        width: "100%",
                                        height: "40px",
                                        ".MuiOutlinedInput-root": {
                                          height: "100%",
                                          border: "none",
                                          borderRadius: "5px",
                                          "&:hover fieldset": {
                                            borderColor: "#CBCBCB",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#CBCBCB",
                                            boxShadow: "none",
                                          },
                                        },
                                        border: "1px solid #CBCBCB",
                                        borderRadius: "5px",
                                        "&:hover": {
                                          border: "none",
                                        },
                                        // marginLeft: '10px'
                                      }}
                                      inputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginTop: "7%" }}>
                                    {/* <Button variant="contained" sx={{width: '100%'}}>Subscribe</Button> */}
                                    <Button
                                      variant="contained"
                                      sx={{
                                        width: "100%",
                                        background: "#161b22",
                                        color: "#667085",
                                        "&:hover": {
                                          background: "#161b22",
                                        },
                                      }}
                                    >
                                      Subscribe
                                    </Button>
                                  </div>
                                </Box>
                              </div>
                              {/* <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                    <TwitterIcon />
                                                </div> */}
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded8
                          ? "600px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded8 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick8}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Social Media Share Buttons
                          {/* <span style={{ color: 'red' }}>*</span> */}
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            This will allow your audienceto share you blog page
                            on social media.
                          </Typography>
                        </Box>
                        {/* {(subscriptionTH === true && mode === 'Free Trial') ?
                                    <Box>
                                        <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Pending Activation</Button>
                                    </Box> :
                                    (subscriptionFromCampList || planDetails?.subscription_level === 'level_0' || planDetails?.subscription_level === 'level_0y'
                                        || planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2'
                                        || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5' || planDetails?.mode == "Free Trial"
                                        || selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
                                        || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5'
                                        || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
                                        || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') ?
                                        <Box>
                                            <Button variant="contained" sx={{ fontWeight: 'bold', fontSize: '16px' }}>Campaign Hacker Premium Feature</Button>
                                        </Box>
                                        : */}
                        <Box>
                          {expanded8 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                        {/* } */}
                      </Button>
                      <Collapse
                        in={
                          expanded8 /* && !subscriptionFromCampList */ /* (planDetails?.subscription_level === 'level_1' || planDetails?.subscription_level === 'level_2' || planDetails?.subscription_level === 'level_4' || planDetails?.subscription_level === 'level_5') */
                        }
                        style={{ marginTop: "2%" }}
                      >
                        {isBrowser ? (
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: isMobile ? "30px" : "55px",
                                  padding: "3%",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          campDetails
                                            ? campDetails?.twitternbutton
                                            : twitternbutton
                                              ? twitternbutton
                                              : false /* localStorage.getItem('twitterBtn') */
                                        }
                                        onChange={handletwitterBtnChange}
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Twitterico /* onClick={shareOnTwitter} style={{cursor: 'pointer'}} */
                                    />
                                  </span>
                                </span>

                                {/* <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={planDetails ? planDetails?.pintrestbutton : (pintrestbutton ? pintrestbutton : false)}
                                                                onChange={handlepintrestBtnChange}
                                                                style={{ color: '#344054', borderColor: '#344054' }}

                                                            />
                                                        }
                                                        label=""
                                                    />
                                                    <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}><Pinterestico  />
                                                    </span>
                                                </span> */}
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          campDetails
                                            ? campDetails?.fbbutton
                                            : fbbutton
                                              ? fbbutton
                                              : false /* localStorage.getItem('fbBtn') */
                                        }
                                        onChange={handlefbBtnChange}
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Fbico /* onClick={shareOnFacebook} style={{cursor: 'pointer'}} */
                                    />
                                  </span>
                                </span>
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          campDetails
                                            ? campDetails?.linkedinbutton
                                            : linkedinbutton
                                              ? linkedinbutton
                                              : false /* localStorage.getItem('linkedinBtn') */
                                        }
                                        onChange={handlelinkedinBtnChange}
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Linkedinico /* onClick={shareOnLinkedin} style={{cursor: 'pointer'}} */
                                    />
                                  </span>
                                </span>
                              </div>
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid container spacing={2}>
                            {/* <Grid item xs={12} sm={12} sx={{
                                                            color: '#344054' }}>
                                                            <div style={{ display: 'flex', gap: isMobile ? '30px' : '55px', padding: '3%', justifyContent: 'center' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={campDetails ? campDetails?.twitternbutton : (twitternbutton ? twitternbutton : false)}
                                                                                onChange={handletwitterBtnChange}
                                                                                style={{ color: '#344054', borderColor: '#344054' }}

                                                                            />
                                                                        }
                                                                        label=""
                                                                    />
                                                                    <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}><Twitterico />
                                                                    </span>
                                                                </span>

                                                                <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={planDetails ? planDetails?.pintrestbutton : (pintrestbutton ? pintrestbutton : false)}
                                                                onChange={handlepintrestBtnChange}
                                                                style={{ color: '#344054', borderColor: '#344054' }}

                                                            />
                                                        }
                                                        label=""
                                                    />
                                                    <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}><Pinterestico />
                                                    </span>
                                                </span>
                                                            </div>
                                                        </Grid> */}

                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: isMobile ? "30px" : "55px",
                                  padding: "3%",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          campDetails
                                            ? campDetails?.twitternbutton
                                            : twitternbutton
                                              ? twitternbutton
                                              : false /* localStorage.getItem('twitterBtn') */
                                        }
                                        onChange={handletwitterBtnChange}
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Twitterico />
                                  </span>
                                </span>

                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          campDetails
                                            ? campDetails?.fbbutton
                                            : fbbutton
                                              ? fbbutton
                                              : false /* localStorage.getItem('fbBtn') */
                                        }
                                        onChange={handlefbBtnChange}
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Fbico />
                                  </span>
                                </span>
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          campDetails
                                            ? campDetails?.linkedinbutton
                                            : linkedinbutton
                                              ? linkedinbutton
                                              : false /* localStorage.getItem('linkedinBtn') */
                                        }
                                        onChange={handlelinkedinBtnChange}
                                        style={{
                                          color: "#d1d5db",
                                          borderColor: "#344054",
                                        }}
                                      />
                                    }
                                    label=""
                                  />
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      display: "block",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Linkedinico />
                                  </span>
                                </span>
                              </div>
                            </Grid>
                          </Grid>
                        )}
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: "3%", paddingLeft: "1%" }}
                >
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        width: "100%",
                        background: "#161b22",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out",
                        maxHeight: expanded12
                          ? "500px"
                          : isMobile
                            ? "150px"
                            : "100px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: isMobile ? "150px" : "100px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          borderBottom: expanded12 ? "1px solid #ddd" : "none",
                          background: "#21262d",
                          justifyContent: "space-between",
                          color: "#e5e7eb",
                          "&:hover": {
                            background: "#30363d",
                          },
                        }}
                        onClick={handleExpandClick12}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          Call To Action (CTA) Button
                          {/* <span style={{ color: 'red' }}>*</span> */}
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              fontSize: "16px",
                              fontWeight: "normal",
                            }}
                          >
                            We will use this as your default CTA button in your
                            blog. You can change this for each blog with the
                            Edit feature
                          </Typography>
                        </Box>
                        <Box>
                          {expanded12 ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </Box>
                      </Button>
                      <Collapse in={expanded12} style={{ marginTop: "2%" }}>
                        <Box
                          sx={{
                            padding: "16px",
                            background: "#0d1117",
                            borderRadius: "0 0 8px 8px",
                            backgroundColor: "#0d1117",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                color: "#d1d5db" /* display: 'flex', */,
                                // alignItems: 'center'
                              }}
                            >
                              <div>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                  }}
                                >
                                  Button Label
                                </Typography>
                                <TextField
                                  // placeholder="Enter your name"
                                  sx={{
                                    backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                    width: "100%",
                                    height: "40px",
                                    ".MuiInputBase-root": {
                                      height: "100%",
                                      border: "none",
                                      borderRadius: "5px",
                                      "&:hover fieldset": {
                                        borderColor: "#CBCBCB",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "#CBCBCB",
                                        boxShadow: "none",
                                      },
                                    },
                                    border: "1px solid #CBCBCB",
                                    borderRadius: "5px",
                                    "&:hover": {
                                      border: "none",
                                    },
                                    // marginLeft: '10px'
                                  }}
                                  value={
                                    campDetails
                                      ? campDetails?.cta_lable
                                      : ctaLabel || "Learn More"
                                  }
                                  onChange={handleCtaLabelChange}
                                />
                              </div>
                              {/* <div style={{ marginTop: '1%' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: 'bold', color: '#ffffff' }}>Upload your profile image</Typography>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ width: '100%' }}
                                                    onChange={handleImageChange}
                                                />
                                                {userImageUrl && (
                                                    <img src={`${userImageUrl}?${Date.now()}`} alt="Uploaded" style={{ maxWidth: '50px', marginTop: '1rem', height: '50px' }} />
                                                )}
                                            </div> */}
                              <div style={{ marginTop: "1%" }}>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                  }}
                                >
                                  Button Link
                                </Typography>
                                <TextField
                                  // placeholder="E.g. https://www.linkedin.com/in/profile_name"
                                  sx={{
                                    backgroundColor: "#161b22",
                                    "& .MuiInputBase-input": { color: "#ffffff" },
                                    width: "100%",
                                    height: "40px",
                                    ".MuiInputBase-root": {
                                      height: "100%",
                                      border: "none",
                                      borderRadius: "5px",
                                      "&:hover fieldset": {
                                        borderColor: "#CBCBCB",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "#CBCBCB",
                                        boxShadow: "none",
                                      },
                                    },
                                    border: "1px solid #CBCBCB",
                                    borderRadius: "5px",
                                    "&:hover": {
                                      border: "none",
                                    },
                                    // marginLeft: '10px'
                                  }}
                                  value={
                                    campDetails
                                      ? campDetails?.cta_link
                                      : ctaLink || sourceUrl || sourceYoutubeUrl
                                  }
                                  onChange={handleCtaLinkChange}
                                />
                              </div>
                              {/* <div style={{ marginTop: '1%' }}>
                                                <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={planDetails ? planDetails?.use_as_default : useAsDefault}
                                                                onChange={handleAuthorUseDefaultChange}
                                                                style={{ color: '#344054', borderColor: '#344054' }}

                                                            />
                                                        }
                                                        label=""
                                                    />
                                                    <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold', color: '#ffffff' }}>Use this information on my blogs.</span>
                                                </span>
                                            </div> */}
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  </Grid>
                </Grid>

                {/* <Grid container spacing={2} sx={{ marginTop: '3%' }}>
                    <Grid item xs={12} sm={12}>
                        <Box
                            sx={{
                                width: '100%',
                                background: '#fff',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                overflow: 'hidden',
                                transition: 'max-height 0.3s ease-in-out',
                                maxHeight: expanded13 ? '500px' : (isMobile ? '160px' : '100px')
                            }}
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    width: '100%',
                                    height: isMobile ? '160px' : '100px',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    borderBottom: expanded13 ? '1px solid #ddd' : 'none',
                                    background: '#D0D5DD',
                                    justifyContent: 'space-between',
                                    color: '#344054',
                                    '&:hover': {
                                        background: '#D0D5DD',
                                    }
                                }}
                                onClick={() => setExpanded13(!expanded13)}
                            >

                                <Box sx={{ textAlign: 'left' }}>
                                    Add Blogs to My Website
                                    <Typography component="span" sx={{ display: 'block', fontSize: '16px', fontWeight: 'normal' }}>
                                        Use the below code to add the blogs we generate to your website.
                                    </Typography>
                                </Box>
                                <Box>
                                    <Tooltip title="Click here for help video">
                                        <img src={youtubeIco1} style={{ fontSize: '34px' }} onClick={() => window.open("https://images.code-genie.ai/images/trafficmonster/iframe_video.mp4", '_blank')} />
                                    </Tooltip>
                                    {expanded13 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </Box>
                            </Button>
                            <Collapse in={expanded13} style={{ marginTop: '2%' }}>
                                <Box
                                    sx={{
                                        padding: '16px',
                                        background: '#f9f9f9',
                                        borderRadius: '0 0 8px 8px',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} sx={{
                                            color: '#344054',
                                        }}>
                                            <TextField variant="outlined" sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: '#9FADBC',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: '#9FADBC',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#9FADBC',
                                                    },
                                                    height: 45
                                                },
                                                width: '100%'
                                            }}
                                                InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                edge="end"
                                                                size="small"
                                                                sx={{
                                                                    marginRight: '4px',
                                                                    background: '#000',
                                                                    borderRadius: '3px',
                                                                    padding: '10%',
                                                                    width: '120%',
                                                                    fontSize: '14px',
                                                                    '&:hover': {
                                                                        background: '#000',
                                                                    },
                                                                }}
                                                                onClick={() => handleCopyCodeSnippet(addtoMyblogscodeSnippet)}
                                                            >
                                                                Copy
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                value={addtoMyblogscodeSnippet} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Collapse>
                        </Box>
                    </Grid>
                </Grid> */}

                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      localStorage.setItem("activeItem", "blogs");
                      navigate("/codegenie/generated-blogs");
                      localStorage.removeItem("campaignid");
                      localStorage.removeItem("returningtocampaign");
                      localStorage.removeItem("sourceurl");
                      localStorage.removeItem("campaignName");
                      localStorage.removeItem("paymentOption");
                      localStorage.removeItem("autoPublish");
                      localStorage.removeItem("limitPublish");
                      localStorage.removeItem("smUrlpublish");
                      localStorage.removeItem("addTags");
                      localStorage.removeItem("captureLeads");
                      localStorage.removeItem("newsLetter");
                      localStorage.removeItem("twitterBtn");
                      localStorage.removeItem("fbBtn");
                      localStorage.removeItem("pintrestBtn");
                      localStorage.removeItem("linkedinBtn");
                      localStorage.removeItem("video");
                      localStorage.removeItem("twitterurl");
                      localStorage.removeItem("fburl");
                      localStorage.removeItem("pintresturl");
                      localStorage.removeItem("linkedinurl");
                      localStorage.removeItem("smUrlpublish");
                      localStorage.removeItem("owndomain");
                      localStorage.removeItem("ChangepayMode");
                      localStorage.removeItem("IdChangingMode");
                      localStorage.removeItem("PaymentSubscription");
                      localStorage.removeItem("Authorurl");
                      localStorage.removeItem("Authorname");
                      localStorage.removeItem("authorDefaultCheck");
                      localStorage.removeItem("videoTag");
                      localStorage.removeItem("podcastUrl");
                      localStorage.removeItem("sourcetext");
                    }}
                  >
                    Close
                  </Button>
                  &ensp;
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (isUploadLoading) {
                        console.log(
                          "Upload in progress, skipping click actions.",
                        );
                        return;
                      }
                      if (planDetails?.payment_status === "pending") {
                        console.log("Handling checkout...");
                        handleCheckout(planDetails?._id);
                      } else if (sourceUrl) {
                        console.log("Handling scrappage...");
                        handlescrappage(sourceUrl);
                      } else {
                        console.log("Handling create campaign...");
                        handleCreateCampaignClick();
                      }
                    }}
                    style={{
                      height: "45px",
                      filter: isUploadLoading ? "blur(2px)" : "none",
                      pointerEvents: isUploadLoading ? "none" : "auto",
                    }} /* disabled={((defaultPlanDetails?.mode == "Free Trial" && FromEdit != "startEditing") || (localStorage.getItem('returningtocampaign') === 'true' && FromEdit != "startEditing") || subscriptionFromCampList || ((planDetails?.subscription_level == 'level_3' || planDetails?.subscription_level == 'level_6') && planDetails?.mode == "Free Trial" && FromEdit != 'startEditing'))} */
                  >
                    {isUpdateLoader || isScrapcheckloading ? (
                      <CircularProgress size={24} style={{ color: "#fff" }} />
                    ) : planDetails?.payment_status === "pending" ? (
                      "Complete Payment"
                    ) : FromEdit === "startEditing" ||
                      localStorage.getItem("ChangepayMode") === "true" ? (
                      "Update Blog"
                    ) : (
                      "Create Blog"
                    )}
                  </Button>
                </div>

                {/* <div style={{ marginTop: '1%', display: 'flex', justifyContent: 'right' }}>
                    <Button variant="outlined" onClick={() => {
                        navigate('/codegenie/generated-blogs');
                        localStorage.removeItem('campaignid');
                        localStorage.removeItem('returningtocampaign');
                        localStorage.removeItem('sourceurl');
                        localStorage.removeItem('campaignName');
                        localStorage.removeItem('paymentOption');
                        localStorage.removeItem('autoPublish');
                        localStorage.removeItem('limitPublish');
                        localStorage.removeItem('smUrlpublish');
                        localStorage.removeItem('addTags');
                        localStorage.removeItem('captureLeads');
                        localStorage.removeItem('newsLetter');
                        localStorage.removeItem('twitterBtn');
                        localStorage.removeItem('fbBtn');
                        localStorage.removeItem('pintrestBtn');
                        localStorage.removeItem('linkedinBtn');
                        localStorage.removeItem('video');
                        localStorage.removeItem('twitterurl');
                        localStorage.removeItem('fburl');
                        localStorage.removeItem('pintresturl');
                        localStorage.removeItem('linkedinurl');
                        localStorage.removeItem('smUrlpublish');
                        localStorage.removeItem('owndomain');
                        localStorage.removeItem('ChangepayMode');
                        localStorage.removeItem('IdChangingMode');
                        localStorage.removeItem('PaymentSubscription');
                        localStorage.removeItem('Authorurl');
                        localStorage.removeItem('Authorname');
                        localStorage.removeItem('authorDefaultCheck');
                        localStorage.removeItem('videoTag');
                        localStorage.removeItem('podcastUrl');
                        localStorage.removeItem('sourcetext');
                    }}>Close</Button>&ensp;<Button variant="contained" onClick={() => {
                        if (planDetails?.payment_status === 'pending') {
                            handleCheckout(planDetails?._id);
                        } else {
                            handleCreateCampaignClick();
                        }
                    }} style={{ filter: isUploadLoading ? 'blur(2px)' : 'none', pointerEvents: isUploadLoading ? 'none' : 'auto' }}>{isUpdateLoader ? <CircularProgress size={24} style={{ color: '#fff' }} /> : planDetails?.payment_status === 'pending' ? 'Complete Payment' : FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' ? 'Update Campaign' : 'Create Campaign'}</Button>

                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
          </Box>
        </Box>

      <Modal
        open={openpaymentInstructModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 600,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          {/* <Typography sx={{ fontSize: '25px' }}>ThankYou!</Typography> */}
          <PriorityHighIcon style={{ color: "yellow", fontSize: "38px" }} />
          <p
            id="child-modal-description"
            style={{
              textAlign:
                "center" /* , fontSize: 'xx-large', marginTop: '22px' */,
            }}
          >
            Please make a payment to complete your process.
          </p>
          <Stack flexDirection="row">
            <Button
              onClick={handleModalPayNowClick}
              variant="contained"
              sx={{ mr: 2 }}
            >
              Pay Now
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={openGetPagesuccessModal}
        onClose={() => setOpenGetPageSuccessModal(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 600,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          <TaskAltIcon style={{ color: "green", fontSize: "40px" }} />
          <p id="child-modal-description" style={{ textAlign: "center" }}>
            We have generated your first blogs. We will automatically generate
            new blogs daily per your selected plan. You can edit each blog from
            the My Blog page with the Edit button and Export the blogs to social
            media or blogging platforms with the Export button. Use the Help
            button on each page to learn more.
          </p>
          <Stack flexDirection="row">
            {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}

            <Button
              onClick={handleGetPageModalClose}
              variant="contained"
              sx={{ mr: 2 }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={confirmCancelSubscription}
        onClose={() => setConfirmCancelSubscription(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 800,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          <InfoIcon style={{ color: "Orange", fontSize: "40px" }} />
          <p
            id="child-modal-description"
            style={{ textAlign: "center", color: "#fff" }}
          >
            When you cancel your subscription you are also canceling the hosting
            of your blog pages. If you would like to keep this content, please
            copy the content to use on a different platform. Once cancelled the
            content will be archived for 30 days then it will be deleted from
            the Traffic Monster servers and from Google Indexing.
          </p>
          <Stack flexDirection="row" sx={{ gap: "10px", marginTop: "2%" }}>
            {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}
            <Button
              onClick={handleCancelSubscriptionClick}
              variant="contained"
              sx={{ /* mr: 2, */ fontWeight: "bolder", fontSize: "17px" }}
            >
              {cancellingLoader ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : (
                "Continue"
              )}
            </Button>
            <Button
              onClick={() => setConfirmCancelSubscription(false)}
              variant="contained"
              sx={{ /* mr: 2, */ fontWeight: "bolder", fontSize: "17px" }}
            >
              Exit
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={upgradeModal}
        /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "40%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: "15px",
            padding: "3%",
          }}
        >
          <Typography style={{ textAlign: "center", fontWeight: "bold" }}>
            <InfoIcon sx={{ color: "#ffcc00" }} />
            <br />
            {((sourceUrl || userBusinessText) &&
              blogcount > planDetails?.blog_count_balance) ||
            ((sourceYoutubeUrl || uploadedvideopath) &&
              blogcount > planDetails?.podcast_count_balance)
              ? "Blog count exceeds your plan limit. Please upgrade your plan to continue."
              : "This feature is not included in your plan.  Please upgrade to have access to this feature."}
          </Typography>

          <Stack
            flexDirection="row"
            sx={{ display: "flex", gap: "10px", marginTop: "1%" }}
          >
            {/* <Button
                            variant="contained"
                            onClick={() => {
                                const value = {
                                    _id: "",
                                    product_name: "CodeGenie",
                                    product_module: genieSelector.module ? genieSelector.module : "",
                                    userid: "",
                                    productid: ""
                                };
                                getProduct(value);
                                localStorage.setItem('fromUpgrade', 'true');
                                navigate('/pricing');
                            }}>
                            Upgrade
                        </Button> */}

            <Button
              onClick={() => setUpgradeModal(false)}
              variant="contained"
              // sx={{ mr: 2, marginTop: '15%' }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={helperPopup}
        /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "70%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: "15px",
            padding: "3%",
          }}
        >
          {/* <video
                        controls
                        style={{ width: '100%' }}
                        src={helpervideosrc}
                        autoPlay
                    /> */}
          <iframe
            width="100%"
            height="500"
            src={helpervideosrc}
            title="Help Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
          <Stack flexDirection="row">
            <Button
              onClick={() => setHelperPopup(false)}
              variant="contained"
              sx={{ mr: 2, marginTop: "15%" }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={topicsList}
        // onClose={() => setTopicsList(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%", // Adjusted width for responsiveness
            maxWidth: 1000,
            bgcolor: "#161b22",
            border: "1px solid #21262d",
            pt: 2,
            px: 4,
            pb: 3,
            height: "85%",
            maxHeight: "110vh",
            overflow: "auto",
            borderRadius: "8px",
            boxShadow: "0px 50px 50px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Stack width="100%">
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  style={{ color: "#fff" }}
                >
                  Blog Topics
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="normal"
                  style={{ color: "#fff" }}
                >
                  Below are some suggested topics to write about. You can also
                  give us a different topic below. Our AI will write about this
                  topic using the content you provided.
                </Typography>
              </Grid>
            </Grid>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#30363d",
                marginTop: "1%",
              }}
            />
            <Box
              sx={{
                maxHeight: "38vh",
                overflowY: "auto",
                marginTop: "1%",
              }}
            >
              <RadioGroup
                value={selectedTopic}
                onChange={(e) => handleTopicSelect(e.target.value)}
              >
                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                  {topics &&
                    topics?.map((topic: any, index: any) => (
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        style={{ padding: "0.5%", height: "50px" }}
                        key={index}
                      >
                        <Button
                          fullWidth
                          color="primary"
                          sx={{
                            textAlign: "left",
                            bgcolor:
                              selectedTopic === topic
                                ? "#3b82f6"
                                : "transparent",
                            color: selectedTopic === topic ? "#fff" : "#CBCBCB",
                            borderColor: "#CBCBCB",
                            "&:hover": { bgcolor: "#3b82f6", color: "#fff" },
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            // minHeight: '30px'
                          }}
                          onClick={() => handleTopicSelect(topic)}
                        >
                          <Radio
                            checked={selectedTopic === topic}
                            value={topic}
                            sx={{
                              color: "#6b7280",
                              "&.Mui-checked": { color: "#60a5fa" },
                            }}
                          />
                          {topic.replace(/-/g, " ")}
                        </Button>
                      </Grid>
                    ))}
                </Grid>
              </RadioGroup>
            </Box>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#30363d",
                marginTop: "1%",
              }}
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              style={{ color: "#fff", textAlign: "center" }}
            >
              Or
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              // label="Selected Topic"
              value={selectedTopic}
              onChange={(e) => setSelectedTopic(e.target.value)}
              // InputProps={{ readOnly: true }}
              sx={{ mt: 3, bgcolor: "#0d1117", borderRadius: "5px", "& .MuiInputBase-input": { color: "#e5e7eb" }, "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "#30363d" } } }}
              placeholder="Input your topic here"
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                // color="primary"
                disabled={!selectedTopic}
                // onClick={() => handleGetPageforCampaign(campaignId, selectedTopic)}
                onClick={() =>
                  handleTopicConfirmation(selectedTopic, 10, campaignId)
                }
                sx={{ color: "#fff" }}
              >
                {isKeywordLoader ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Continue"
                )}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={keywordsList}
        // onClose={() => setTopicsList(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            maxWidth: 1000,
            bgcolor: "#161b22",
            border: "1px solid #21262d",
            pt: 2,
            px: 4,
            pb: 3,
            height: "87%",
            maxHeight: "110vh",
            overflow: "auto",
            borderRadius: "8px",
            boxShadow: "0px 50px 50px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Stack width="100%">
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  style={{ color: "#fff" }}
                >
                  Keyword Suggestions
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="normal"
                  style={{ color: "#fff" }}
                >
                  Below are some keywords that we suggest could help you with
                  traffic for your blog. Pick one or add your own. Keep in mind
                  that the higher the potential traffic the more difficult it
                  may be for your blog to rank high in google search results.
                </Typography>
              </Grid>
            </Grid>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#30363d",
                marginTop: "1%",
              }}
            />

            <Box
              sx={{
                maxHeight: "38vh",
                overflowY: "auto",
                marginTop: "1%",
              }}
            >
              <RadioGroup
                value={selectedKeyword}
                onChange={(e) => handleKeywordSelect(e.target.value)}
              >
                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                  {keywords && keywords.length > 0 ? (
                    <Table sx={{ width: "100%", padding: "1%" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#fff",
                              borderBottom: "1px solid #CBCBCB",
                              background: "#3b82f6",
                            }}
                          >
                            Select
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#fff",
                              borderBottom: "1px solid #CBCBCB",
                              background: "#3b82f6",
                            }}
                          >
                            Keyword
                          </TableCell>
                          {/* <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Potential Traffic</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {keywords.map((keyword: any, index: any) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": { bgcolor: "#1d4ed8", color: "#fff" },
                              bgcolor:
                                selectedKeyword === keyword.keyword
                                  ? "#1d4ed8"
                                  : "transparent",
                            }}
                          >
                            <TableCell
                              sx={{ borderBottom: "1px solid #CBCBCB" }}
                            >
                              <Radio
                                checked={selectedKeyword === keyword.keyword}
                                value={keyword.keyword}
                                onChange={() =>
                                  handleKeywordSelect(keyword.keyword)
                                }
                                sx={{
                                  color: "#4b5563",
                                  "&.Mui-checked": { color: "#3b82f6" },
                                }}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                color:
                                  selectedKeyword === keyword.keyword
                                    ? "#fff"
                                    : "#CBCBCB",
                                borderBottom: "1px solid #CBCBCB",
                              }}
                            >
                              {keyword.keyword}
                            </TableCell>
                            {/* <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.potentical_traffic}
                                                        </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <div className="alert alert-info" role="alert">
                      Keyword search failed, Please try again.
                    </div>
                  )}
                </Grid>
              </RadioGroup>
            </Box>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#30363d",
                marginTop: "1%",
              }}
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              style={{ color: "#fff", textAlign: "center" }}
            >
              Or
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              // label="Selected Topic"
              value={selectedKeyword}
              onChange={(e) => setSelectedKeyword(e.target.value)}
              // InputProps={{ readOnly: true }}
              sx={{ mt: 3, bgcolor: "#0d1117", borderRadius: "5px", "& .MuiInputBase-input": { color: "#e5e7eb" }, "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "#30363d" } } }}
              placeholder="Input your keyword here"
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={() =>
                  handleTopicConfirmation(selectedTopic, 10, campaignId)
                }
                sx={{ color: "#fff" }}
              >
                {isKeywordLoader ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Retry"
                )}
              </Button>
              <Button
                variant="contained"
                // color="primary"
                disabled={!selectedKeyword}
                sx={{ color: "#fff" }}
                onClick={() =>
                  handleGetPageforCampaign(
                    user_email,
                    campaignId,
                    selectedTopic,
                    selectedKeyword,
                  )
                }
              >
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </Box>
    </>
  );
};

export default New_Campaign;